// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:08.814Z
// Property: Tuscany Ranch Apartments (ID: 6767906449165639)
// Collections: 29 amenities, 10 floorplans (live), 43 photos, 57 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165639",
  "property_external_id": "4x751mk",
  "property_zillow_url": "https://www.zillow.com/b/tuscany-ranch-waco-tx-CkBMpJ/",
  "property_apartments_url": "https://www.apartments.com/tuscany-ranch-apartments-waco-tx/4x751mk/",
  "property_google_business_url": "https://www.google.com/maps/place/Tuscany+Ranch/data=!4m2!3m1!1s0x0:0x5e6d1c0f800cc4a?sa=X&ved=2ahUKEwislvKQgr2SAxXznGoFHYU9AwQQ_BJ6BAg_EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "tuscany-ranch-apartments",
  "property_name": "Tuscany Ranch Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/tx/waco/tuscany-ranch/",
  "property_domain": null,
  "property_address": "2100 South New Road",
  "property_full_address": "2100 South New Road, Waco, TX, 76711",
  "property_address_1": "2100 South New Road",
  "property_address_2": null,
  "property_address_city": "Waco",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "76711",
  "property_address_country": "US",
  "property_address_county": "McLennan County",
  "property_neighborhood_address": "Waco",
  "property_address_latitude": "31.50859",
  "property_address_longitude": "-97.15239",
  "property_email": "tuscanyranch@caseusa.com",
  "property_phone": "(254) 328-1637",
  "property_call_tracking_phone": "844-394-8950",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Tuscany Ranch Apartments in Waco, Texas, enjoy spacious one- and two-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and pet-friendly spaces. With thoughtful touches such as a concierge service and walking trails, your perfect retreat awaits. Make Tuscany Ranch your home today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Tuscany Ranch Apartments in beautiful Waco, Texas, where modern living meets comfort and convenience. Our community offers spacious and thoughtfully designed one and two-bedroom floor plans, perfect for any lifestyle. Each apartment features premium amenities, including air conditioning, stainless steel appliances, washer/dryer hookups, and large walk-in closets to ensure you feel right at home.\n\nDiscover the exceptional amenities that make Tuscany Ranch stand out. Take a refreshing dip in our sparkling pool, stay active in our fully equipped fitness center, or unwind in our stylish clubhouse. For those who work remotely or need a quiet place for study, our business center and multi-use room offer just what you need. Enjoy the outdoors? Our beautifully landscaped grounds feature walking and biking trails, a picnic area, and a pet-friendly dog park, making it a great place for your furry friends.\n\nSafety and convenience are priorities here with controlled access, 24-hour maintenance on-site, and a dedicated property manager. Plus, our online services and planned social activities foster a vibrant community atmosphere. Don’t forget to take advantage of our breakfast/coffee concierge service – it’s just one of the many thoughtful touches that elevate your living experience.\n\nReady to elevate your lifestyle? Find your new home today and explore our availability or schedule a tour to experience Tuscany Ranch Apartments firsthand. Your ideal apartment awaits in Waco, Texas!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4c-9a84-7204-b5b6-01b22c8de197.webp",
  "property_featured_image_media": {
    "alt_text": "Tuscany Ranch apartment building exterior with arched windows and a tower.",
    "public_id": "019cfb4c-9a84-7204-b5b6-01b22c8de197",
    "storage_key": "property/6767906449165639/019cfb4c-9a84-7204-b5b6-01b22c8de197.webp",
    "width": 2048,
    "height": 1534
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "260",
  "property_year_built": "2016",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.46153846153847",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Aggressive breads",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed. Breed restrictions apply. Pet rent is $30 per pet per month. $500 fee per pet (non‑refundable).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://tuscanyranchapartmentswaco.securecafe.com/onlineleasing/tuscany-ranch-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://tuscanyranchapartmentswaco.securecafe.com/residentservices/tuscany-ranch-apartments/userlogin.aspx",
  "property_apply_now_url": "https://tuscanyranchapartmentswaco.securecafe.com/onlineleasing/tuscany-ranch-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4c-b2c9-72be-804c-2f3bab4f8a57.webp",
  "property_primary_logo_media": {
    "alt_text": "Tuscany Ranch Apartment Homes logo.",
    "public_id": "019cfb4c-b2c9-72be-804c-2f3bab4f8a57",
    "storage_key": "property/6767906449165639/019cfb4c-b2c9-72be-804c-2f3bab4f8a57.webp",
    "width": 640,
    "height": 392
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4c-9251-74bf-b048-b3d77a1840ef.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb4c-9251-74bf-b048-b3d77a1840ef",
    "storage_key": "property/6767906449165639/019cfb4c-9251-74bf-b048-b3d77a1840ef.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4c-c2bf-705c-af59-676ab465409b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Tuscany Ranch apartment homes logo.",
    "public_id": "019cfb4c-c2bf-705c-af59-676ab465409b",
    "storage_key": "property/6767906449165639/019cfb4c-c2bf-705c-af59-676ab465409b.webp",
    "width": 640,
    "height": 392
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb89-288b-777d-a1b0-444f02185f3a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Tuscany Ranch logo",
    "public_id": "019cfb89-288b-777d-a1b0-444f02185f3a",
    "storage_key": "property/6767906449165639/019cfb89-288b-777d-a1b0-444f02185f3a.webp",
    "width": 640,
    "height": 392
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#4e5147",
  "property_secondary_color": "#c9bdac",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#7b8070",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "856 - 1176",
  "property_sqft_min": "856",
  "property_sqft_max": "1176",
  "property_price_range": "1419 - 1789",
  "property_price_min": "1419",
  "property_price_max": "1789",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/TuscanyRanchApartments/",
  "property_instagram_url": "https://www.instagram.com/tuscanyranchapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJsf828WWBT4YRSswA-MDR5gU",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/tuscany-ranch-waco",
  "property_tiktok_url": "https://www.tiktok.com/discover/tuscany-ranch-apartments-waco-tx",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Tuscany Ranch Apartments",
  "property_home_romance_title": "Embrace Your Sanctuary, Discover the Perfect Place to Thrive",
  "property_home_amenities_blurb": "Welcome to Tuscany Ranch Apartments in Waco, Texas—a vibrant community where comfort meets convenience. Choose from spacious one and two-bedroom floor plans featuring modern amenities like stainless steel appliances and walk-in closets. Unwind by the pool, socialize in the clubhouse, or stroll through scenic walking trails—all within your gated sanctuary.",
  "property_home_floorplans_blurb": "Welcome to Tuscany Ranch Apartments in Waco, Texas, where comfort meets style. Choose from our thoughtfully designed one- and two-bedroom floor plans, each tailored to elevate your living experience. Browse our available apartment homes and find the perfect space for your next chapter in life. Your serene retreat awaits!",
  "property_home_gallery_blurb": "At Tuscany Ranch Apartments in Waco, Texas, luxury meets comfort. Choose from thoughtfully designed one- and two-bedroom floor plans featuring modern amenities like spacious walk-in closets, stainless steel appliances, and a private balcony. Enjoy a resort-style pool, fitness center, and vibrant community activities. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Tuscany Ranch Apartments in vibrant Waco, Texas! Nestled in a charming neighborhood, our one and two-bedroom floor plans offer comfort and convenience. Experience local favorites and hidden gems just steps away—let the vibrant energy of the community inspire your next adventure. Uncover the perfect neighborhood today!",
  "property_home_reviews_blurb": "At Tuscany Ranch Apartments in Waco, Texas, you'll find beautifully spacious homes that residents rave about. One happy resident shares, \"I loveeeee it...the apartments are really pretty, well laid out, and much quieter than other places.\" Experience the joy of quiet living and vibrant community life—see what our residents have to say!",
  "property_neighborhood_blurb": "At Tuscany Ranch Apartments in Waco, Texas, your ideal living space is just the beginning. Nestled near esteemed educational institutions like Baylor University and McLennan Community College, our community offers unparalleled access to vibrant local culture and top-rated schools, including Kendrick Elementary and University High School. See what's around our community and discover local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Tuscany Ranch Apartments in vibrant Waco, Texas, you’ll find an exceptional blend of comfort and convenience. Revel in elegant floor plans featuring spacious one and two bedrooms, complemented by resort-style amenities like a sparkling pool, state-of-the-art fitness center, and inviting clubhouse. Elevate your living experience today!",
  "property_applynow_blurb": "At Tuscany Ranch Apartments in Waco, Texas, your ideal living space awaits! Choose from our spacious one- and two-bedroom floor plans, complemented by exceptional amenities like a refreshing pool, a state-of-the-art fitness center, and a vibrant pet play area. Begin your journey to comfort—lease online today!",
  "property_contactus_blurb": "At Tuscany Ranch Apartments in Waco, Texas, our diverse floor plans, including spacious one and two-bedroom options, cater to your lifestyle. Enjoy the perfect blend of comfort and convenience. Have questions? Contact our leasing team today to find out more about your future home!",
  "property_faqs_blurb": "Tuscany Ranch Apartments in Waco, Texas, offers thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Ready to learn more about our vibrant community? Visit our FAQs page for insights and answers to your burning questions, ensuring you find the perfect home tailored just for you!",
  "property_floorplans_blurb": "At Tuscany Ranch Apartments in Waco, Texas, our thoughtfully designed floor plans cater to your lifestyle. Choose from cozy one-bedroom retreats or spacious two-bedroom layouts. Each home is a canvas for your ideal living experience. Browse our available apartment homes and uncover the perfect space for you today!",
  "property_gallery_blurb": "At Tuscany Ranch Apartments in Waco, Texas, your ideal lifestyle awaits. Choose from spacious one or two-bedroom floor plans, each featuring modern finishes and generous walk-in closets. Revel in our luxurious amenities, from a refreshing pool to a vibrant clubhouse. Picture yourself living here—your new home is just a click away!",
  "property_interactivemap_blurb": "At Tuscany Ranch Apartments in Waco, Texas, you’ll find the ideal blend of comfort and convenience. Choose from spacious one- and two-bedroom floor plans, all with top-notch amenities like a refreshing pool, state-of-the-art fitness center, and a delightful dog park. Check out our interactive community map to envision your new life!",
  "property_pets_blurb": "At Tuscany Ranch Apartments in Waco, TX, your furry friends can thrive alongside you! With no weight limits and room for two pets, each pooch or kitty will enjoy a warm, welcoming home. Discover the perfect blend of comfort and convenience—where pet-friendly living meets modern apartment standards.",
  "property_referafriend_blurb": "At Tuscany Ranch Apartments in Waco, TX, spacious one and two-bedroom floor plans create the perfect backdrop for a vibrant lifestyle. Share the joy of comfortable living with great friends—refer a friend to our welcoming community today and enjoy the benefits of having wonderful neighbors by your side!",
  "property_residentaccess_blurb": "Welcome to Tuscany Ranch Apartments in Waco, Texas, where comfort meets convenience. Choose from our thoughtfully designed one and two-bedroom floor plans to find your perfect sanctuary. Access your resident portal today to pay rent, schedule maintenance, and take advantage of exclusive community updates—all at your fingertips!",
  "property_reviews_blurb": "At Tuscany Ranch Apartments in Waco, Texas, residents celebrate their community's charm and tranquility. One satisfied tenant raves, “The crowd is much more grown up here, so it's much quieter than other places.” Experience spacious, beautifully laid-out apartments, and find out why our residents love calling Tuscany Ranch home!",
  "property_created_at": "1753982396132",
  "property_scheduletour_blurb": "At Tuscany Ranch Apartments in Waco, Texas, your new home awaits! Choose from spacious one- and two-bedroom floor plans designed for comfort and style. Ready to see the difference? Schedule a tour today and hear firsthand from our residents why they love calling this community home!",
  "property_thankyou_blurb": "Thank you for your interest in Tuscany Ranch Apartments in Waco, Texas! Our stylish one and two-bedroom floor plans offer the perfect blend of comfort and modern living. Keep an eye on your inbox—our team will reach out shortly to help you find your ideal home!",
  "property_virtualtours_blurb": "Welcome to Tuscany Ranch Apartments, where Texas charm meets modern living in Waco. Our spacious one and two-bedroom floor plans offer a perfect blend of comfort and style. Curious about your future home? Step inside with our immersive virtual tour and envision your ideal lifestyle in our vibrant community!",
  "property_copyright": "2025 All Rights Reserved. Tuscany Ranch Apartments",
  "property_seo_title_home": "Tuscany Ranch Apartments | Apartments in Waco, Texas",
  "property_seo_description_home": "Embrace luxury living at Tuscany Ranch Apartments in Waco, TX! Enjoy spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Waco, Texas",
  "property_seo_description_floorplans": "Find your ideal space at Tuscany Ranch Apartments in Waco, TX! Choose from stylish one and two-bedroom floor plans that suit your lifestyle perfectly.",
  "property_seo_title_amenities": "Amenities | Waco, Texas Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Tuscany Ranch Apartments in Waco, TX! Enjoy a sparkling pool, fitness center, pet-friendly spaces, and spacious floor plans.",
  "property_seo_title_gallery": "Gallery | Apartments in Waco, Texas",
  "property_seo_description_gallery": "\"Imagine life at Tuscany Ranch Apartments in Waco! Dive into stunning photos of spacious one- and two-bedroom homes with resort-style amenities. Your dream awaits!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Tuscany Ranch Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Tuscany Ranch Apartments in Waco, TX! Transform your lifestyle with our spacious one and two-bedroom floor plans. Take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Tuscany Ranch Apartments Apartments",
  "property_seo_description_interactivemap": "Uncover your ideal home at Tuscany Ranch Apartments in Waco, TX. From spacious floor plans to inviting amenities, your perfect lifestyle awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Waco, Texas",
  "property_seo_description_neighborhood": "Uncover the charm of Tuscany Ranch Apartments in Waco, TX. Dive into local favorites and explore vibrant nearby spots that make our neighborhood shine!",
  "property_seo_title_contact": "Contact Us | Tuscany Ranch Apartments",
  "property_seo_description_contact": "Experience the charm of Tuscany Ranch Apartments in Waco, TX. From cozy one-bedroom to spacious two-bedroom floor plans, we're here to assist—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Waco, Texas",
  "property_seo_description_faqs": "Uncover the details of Tuscany Ranch Apartments in Waco, TX. Browse our FAQs to find answers about our vibrant community, amenities, and unique floor plans!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Waco, Texas",
  "property_seo_description_reviews": "Experience Tuscany Ranch Apartments in Waco, TX! From spacious floor plans to top-notch amenities like a pool and pet park, see why residents love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Waco, Texas",
  "property_seo_description_applynow": "Experience comfort and luxury at Tuscany Ranch Apartments in Waco, TX. With top-notch amenities and spacious floor plans, your perfect home awaits! Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Tuscany Ranch Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Tuscany Ranch Apartments! Log in to manage your rent, schedule maintenance, and enhance your Waco living experience today!",
  "property_seo_title_referafriend": "Refer A Friend | Tuscany Ranch Apartments",
  "property_seo_description_referafriend": "\"Great friends make Tuscany Ranch feel like home! Refer a friend today and enjoy living in Waco’s vibrant community together. Let's grow your neighborhood!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Tuscany Ranch Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Tuscany Ranch Apartments in Waco, TX. Schedule your tour today and step into a vibrant community designed for your lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Tuscany Ranch Apartments",
  "property_seo_description_privacy": "At Tuscany Ranch Apartments in Waco, TX, your privacy matters. Review our comprehensive policy to learn how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Tuscany Ranch Apartments",
  "property_seo_description_accessibility": "\"At Tuscany Ranch Apartments in Waco, TX, we're committed to accessibility for all. Join a community that prioritizes digital inclusion and convenience!\"",
  "property_seo_title_sitemap": "Sitemap | Tuscany Ranch Apartments",
  "property_seo_description_sitemap": "Navigate the charm of Tuscany Ranch Apartments in Waco, TX! Uncover a world of amenities and community features—check out our sitemap for more details!",
  "property_seo_title_thankyou": "Thank You | Tuscany Ranch Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Tuscany Ranch Apartments! Our team will connect soon to help you find your perfect Waco home. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Waco, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866066343",
  "amenities": [
    {
      "id": "ec_b0c04738c4ba967b341ea670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127728542",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45da03c07ebda3a803d1b35a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397386",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f16a8321684e960deaeaa451",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397387",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6001569e132bcb8d9714dc60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397388",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b274249fa8375abcda6bd996",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397390",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87c27305e8abd09495856f3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397382",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c653b1b6ac98e21e3bab56e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397389",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80e0cd5ca07c62aa1152132e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397391",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11a583d8dd4a4b5df99a0ccf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397392",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79ff24e2962869b7992ffd73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397385",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_739c00e936b390839cf04058",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397393",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db9e6427559982517f49fd12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127397394",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bf701d5fb67161195bf18d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "128017310",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d9be755f4deab84c5dd346a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "128042570",
      "title": "Astound Broadband by Grande",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3088620c621b6a5b3f0f21c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398832",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ef587d5080c71e24e63a6387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398833",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72b4e0652b87058d2eb2ef7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398834",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5ba5f00f29770dcd623b2e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398835",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ccec43ccd4218ff9b6551e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398836",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_062e0b4e2d9049fcf5e29726",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398837",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7976e9e4ef3afd04700c44e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398838",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13c4746a8401a40dae369bd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398839",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3ccb1636ce05b9e28c78db6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398840",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89b5444bd1c49a07b798c8de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398841",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fd0bfd0dca691e3c672281e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398842",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be9c83d2a9b92c69ae427d32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398843",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c39739a6ca9713be7feb2fa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398844",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75d5da02d368f4b8535f34ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398845",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f11c4eb8cf4d0e2add85131b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "yardi",
      "external_id": "127398846",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5d25feeb25b31729748e12b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-df32-705e-aa7c-1b161e4444e9.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four green chairs, featuring modern artwork on a gray wall.",
        "public_id": "019cfb4a-df32-705e-aa7c-1b161e4444e9",
        "storage_key": "property/6767906449165639/019cfb4a-df32-705e-aa7c-1b161e4444e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy stylish dining in this apartment's dedicated dining area, complete with a modern table and chairs.",
      "link": "false",
      "alt_text": "Dining area with a round table and four green chairs, featuring modern artwork on a gray wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7447.jpg"
    },
    {
      "id": "ec_81736475fdb186a6a46cc1e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-df06-74f1-87aa-77a165b4fe62.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray fireplace, a large round mirror above it, and a plush sofa.",
        "public_id": "019cfb4a-df06-74f1-87aa-77a165b4fe62",
        "storage_key": "property/6767906449165639/019cfb4a-df06-74f1-87aa-77a165b4fe62.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy up by the fireplace in this beautifully appointed living room, featuring plush seating and elegant decor for a comfortable and stylish atmosphere.",
      "link": "false",
      "alt_text": "Modern living room with a gray fireplace, a large round mirror above it, and a plush sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7591.jpg"
    },
    {
      "id": "ec_979bd4fdf0398c02ab8284aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-deed-760a-825c-e0351d28f6bb.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace, large sofa, and coffee table.",
        "public_id": "019cfb4a-deed-760a-825c-e0351d28f6bb",
        "storage_key": "property/6767906449165639/019cfb4a-deed-760a-825c-e0351d28f6bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and inviting living room featuring a gas fireplace, plush seating, and tasteful decor, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a fireplace, large sofa, and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7571.jpg"
    },
    {
      "id": "ec_2ec59df67f0ebd86ec5dd4cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-df14-76c4-8584-3a5dd8046e01.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a washer and dryer in a nearby closet.",
        "public_id": "019cfb4a-df14-76c4-8584-3a5dd8046e01",
        "storage_key": "property/6767906449165639/019cfb4a-df14-76c4-8584-3a5dd8046e01.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish bathroom vanity with a washer and dryer conveniently located in an adjacent closet, perfect for modern living.",
      "link": "false",
      "alt_text": "Bathroom vanity with a washer and dryer in a nearby closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7359.jpg"
    },
    {
      "id": "ec_db720d0e7047e28992f13394",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-e4d6-708d-8b8a-51afc412928d.webp",
      "image_media": {
        "alt_text": "Cozy community lounge area with a fireplace and seating.",
        "public_id": "019cfb4a-e4d6-708d-8b8a-51afc412928d",
        "storage_key": "property/6767906449165639/019cfb4a-e4d6-708d-8b8a-51afc412928d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring a warm fireplace and comfortable seating areas perfect for socializing or quiet reflection.",
      "link": "false",
      "alt_text": "Cozy community lounge area with a fireplace and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7122.jpg"
    },
    {
      "id": "ec_5fc0e94989928ffedb8526aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-defe-76fd-9e50-6afaf847b34f.webp",
      "image_media": {
        "alt_text": "Closet with shelves and a basket",
        "public_id": "019cfb4a-defe-76fd-9e50-6afaf847b34f",
        "storage_key": "property/6767906449165639/019cfb4a-defe-76fd-9e50-6afaf847b34f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with built-in shelves and grey carpet, perfect for storage.",
      "link": "false",
      "alt_text": "Closet with shelves and a basket",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7280.jpg"
    },
    {
      "id": "ec_d7254a76c89426a1271b10dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-df48-7438-9fcf-b194f1b6c4bc.webp",
      "image_media": {
        "alt_text": "Tuscany Ranch community building with arched entrance and tower.",
        "public_id": "019cfb4a-df48-7438-9fcf-b194f1b6c4bc",
        "storage_key": "property/6767906449165639/019cfb4a-df48-7438-9fcf-b194f1b6c4bc.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Discover the inviting atmosphere of Tuscany Ranch, featuring a charming community building with an arched entrance and a distinctive tower. Experience comfortable living in a beautiful setting.",
      "link": "false",
      "alt_text": "Tuscany Ranch community building with arched entrance and tower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7545.jpg"
    },
    {
      "id": "ec_4c4e19946fcd7036204cb6f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-da45-74d7-b36e-6e661931d123.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, stainless steel appliances including a microwave and stove, and a sink.",
        "public_id": "019cfb4a-da45-74d7-b36e-6e661931d123",
        "storage_key": "property/6767906449165639/019cfb4a-da45-74d7-b36e-6e661931d123.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this modern kitchen featuring sleek stainless steel appliances, ample cabinet space, and a double sink. Perfect for everyday cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, stainless steel appliances including a microwave and stove, and a sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7580.jpg"
    },
    {
      "id": "ec_8f7c7d3d86c88ef66a5e3084",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-da26-70cf-850f-07ff65ea647e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan.",
        "public_id": "019cfb4a-da26-70cf-850f-07ff65ea647e",
        "storage_key": "property/6767906449165639/019cfb4a-da26-70cf-850f-07ff65ea647e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a ceiling fan for added comfort.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7383.jpg"
    },
    {
      "id": "ec_1741c39fb3130bec0bce6a07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-df0f-7368-a6fe-467ef2e20cba.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, vanity, and shower curtain.",
        "public_id": "019cfb4a-df0f-7368-a6fe-467ef2e20cba",
        "storage_key": "property/6767906449165639/019cfb4a-df0f-7368-a6fe-467ef2e20cba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a toilet, sink, vanity with ample counter space, and a white shower curtain for privacy.",
      "link": "false",
      "alt_text": "Bathroom with toilet, sink, vanity, and shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7398.jpg"
    },
    {
      "id": "ec_4f91c48a2bac649489ed6162",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-f1b6-75bc-a160-e2758ef40b48.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with pergola and lounge chairs.",
        "public_id": "019cfb4a-f1b6-75bc-a160-e2758ef40b48",
        "storage_key": "property/6767906449165639/019cfb4a-f1b6-75bc-a160-e2758ef40b48.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our shaded outdoor seating area, complete with comfortable lounge chairs and a table for gathering.",
      "link": "false",
      "alt_text": "Outdoor seating area with pergola and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7171.jpg"
    },
    {
      "id": "ec_b6b12c69a900be8e733cb0ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-1db2-7078-b0cb-f124ccf9495b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with blue patterned shower curtain, white tiled shower, wooden vanity, and marble countertop.",
        "public_id": "019cfb4b-1db2-7078-b0cb-f124ccf9495b",
        "storage_key": "property/6767906449165639/019cfb4b-1db2-7078-b0cb-f124ccf9495b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Freshen up in this modern bathroom featuring a sleek wooden vanity, marble countertops, and a bright blue patterned shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom with blue patterned shower curtain, white tiled shower, wooden vanity, and marble countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7237.jpg"
    },
    {
      "id": "ec_7c2cafa7dadeef2c304fab0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-f3e0-77d5-bf1e-56046b9ab6a6.webp",
      "image_media": {
        "alt_text": "View of the pool and apartment buildings from a balcony with a table and chairs.",
        "public_id": "019cfb4a-f3e0-77d5-bf1e-56046b9ab6a6",
        "storage_key": "property/6767906449165639/019cfb4a-f3e0-77d5-bf1e-56046b9ab6a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoor swimming pool and scenic views from your private balcony, surrounded by lush landscaping and apartment buildings.",
      "link": "false",
      "alt_text": "View of the pool and apartment buildings from a balcony with a table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7485.jpg"
    },
    {
      "id": "ec_327d2ed50b732ddf294c7ef0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-f663-7770-93dc-fd77058a472e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dark wood dresser, nightstands, and a ceiling fan.",
        "public_id": "019cfb4a-f663-7770-93dc-fd77058a472e",
        "storage_key": "property/6767906449165639/019cfb4a-f663-7770-93dc-fd77058a472e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with plush pillows and a dark throw blanket, complemented by elegant dark wood furniture including a dresser and nightstands. Large windows with blinds allow natural light to fill the room.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dark wood dresser, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7626.jpg"
    },
    {
      "id": "ec_690e702ebc8b73b154401a1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-f6a6-712b-989b-c70caffdbbb7.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, blue bedding, and a nightstand with a lamp.",
        "public_id": "019cfb4a-f6a6-712b-989b-c70caffdbbb7",
        "storage_key": "property/6767906449165639/019cfb4a-f6a6-712b-989b-c70caffdbbb7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this inviting bedroom, featuring a comfortable queen-size bed with plush blue linens and decorative pillows. A charming nightstand with a lamp adds a warm glow.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, blue bedding, and a nightstand with a lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7223.jpg"
    },
    {
      "id": "ec_4f8aa9f75105d49b67c1ee7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4a-f99e-7061-aaa8-fcd9023701fe.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and doorway to storage area with baskets.",
        "public_id": "019cfb4a-f99e-7061-aaa8-fcd9023701fe",
        "storage_key": "property/6767906449165639/019cfb4a-f99e-7061-aaa8-fcd9023701fe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a modern vanity with a sleek countertop and sink, ample storage, and decorative accents. A nearby doorway reveals a charming alcove with woven baskets.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and doorway to storage area with baskets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7462.jpg"
    },
    {
      "id": "ec_7ca7ad84b3073bbc3d6b5a77",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-00ae-7729-a455-4980fdf203e6.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, coffee table, and view of kitchen with bar stools.",
        "public_id": "019cfb4b-00ae-7729-a455-4980fdf203e6",
        "storage_key": "property/6767906449165639/019cfb4b-00ae-7729-a455-4980fdf203e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a fireplace, comfortable sofa, and coffee table, seamlessly opening to a modern kitchen with a breakfast bar.",
      "link": "false",
      "alt_text": "Living room with fireplace, sofa, coffee table, and view of kitchen with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7290.jpg"
    },
    {
      "id": "ec_fd6fec4c3aa9a2b662ca83cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-0370-74c0-a2d4-1060841afdab.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, and a desk with a lamp and globe.",
        "public_id": "019cfb4b-0370-74c0-a2d4-1060841afdab",
        "storage_key": "property/6767906449165639/019cfb4b-0370-74c0-a2d4-1060841afdab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy spacious dining and dedicated workspace in this beautifully appointed apartment, featuring ample natural light and stylish furnishings.",
      "link": "false",
      "alt_text": "Dining area with table and chairs, and a desk with a lamp and globe.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7335.jpg"
    },
    {
      "id": "ec_dffdf6a9f9df4cdf88c57f15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-3180-745f-a5fb-19544bf1764a.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, ceiling fan, and dresser.",
        "public_id": "019cfb4b-3180-745f-a5fb-19544bf1764a",
        "storage_key": "property/6767906449165639/019cfb4b-3180-745f-a5fb-19544bf1764a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic and comfortable bedroom featuring a king-size bed with striped linens, a plush headboard, and a modern ceiling fan. A dresser and nightstand with lamps complete the inviting space.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-size bed, ceiling fan, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7467.jpg"
    },
    {
      "id": "ec_848599d706684dd6bb7a742d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-0558-7098-815f-b18c58513992.webp",
      "image_media": {
        "alt_text": "Dining table and chairs with artwork of horses on the wall, and a desk area in the background.",
        "public_id": "019cfb4b-0558-7098-815f-b18c58513992",
        "storage_key": "property/6767906449165639/019cfb4b-0558-7098-815f-b18c58513992.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish dining area with a dark wood table and chairs, complemented by a captivating horse-themed wall art. Adjacent is a functional desk space, perfect for a home office setup.",
      "link": "false",
      "alt_text": "Dining table and chairs with artwork of horses on the wall, and a desk area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7596.jpg"
    },
    {
      "id": "ec_d0c117fca7313c1694e8dfae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-0d3b-758f-9471-3dc963ff69ff.webp",
      "image_media": {
        "alt_text": "Stylish living room with a sofa, armchair, coffee table, and dining area.",
        "public_id": "019cfb4b-0d3b-758f-9471-3dc963ff69ff",
        "storage_key": "property/6767906449165639/019cfb4b-0d3b-758f-9471-3dc963ff69ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living room featuring a comfortable sofa, accent armchair, coffee table, and a dedicated dining space. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Stylish living room with a sofa, armchair, coffee table, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7422.jpg"
    },
    {
      "id": "ec_6999b1ef6e0bf3ed28a1932a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-1317-7421-a289-3645da9b1822.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables, a fireplace, and grills.",
        "public_id": "019cfb4b-1317-7421-a289-3645da9b1822",
        "storage_key": "property/6767906449165639/019cfb4b-1317-7421-a289-3645da9b1822.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and gatherings with our community grilling area, featuring picnic tables and built-in grills.",
      "link": "false",
      "alt_text": "Outdoor grilling area with picnic tables, a fireplace, and grills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7495.jpg"
    },
    {
      "id": "ec_96fb212005ea41eda73d8085",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-13e5-7423-813b-83441961c20b.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, cabinet, and a washing machine in the corner.",
        "public_id": "019cfb4b-13e5-7423-813b-83441961c20b",
        "storage_key": "property/6767906449165639/019cfb4b-13e5-7423-813b-83441961c20b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Updated bathroom featuring a wood vanity with ample storage, a modern sink, and a convenient in-unit washer and dryer.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, cabinet, and a washing machine in the corner.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7350.jpg"
    },
    {
      "id": "ec_e0580e006d44dde8c0bfc2f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-13e4-7463-9eab-4fc0091bff9f.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a dining table, fireplace, and seating areas.",
        "public_id": "019cfb4b-13e4-7463-9eab-4fc0091bff9f",
        "storage_key": "property/6767906449165639/019cfb4b-13e4-7463-9eab-4fc0091bff9f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a large dining table, a cozy fireplace, and comfortable seating areas perfect for socializing.",
      "link": "false",
      "alt_text": "Spacious community lounge with a dining table, fireplace, and seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7132.jpg"
    },
    {
      "id": "ec_2d8c3b4f33e32b8bfdca75b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-1b06-70f5-b1f1-d220b23ea826.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with a white couch, fireplace, and dining bar.",
        "public_id": "019cfb4b-1b06-70f5-b1f1-d220b23ea826",
        "storage_key": "property/6767906449165639/019cfb4b-1b06-70f5-b1f1-d220b23ea826.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this open-concept apartment, featuring a modern kitchen and a cozy living area perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Spacious living room and kitchen area with a white couch, fireplace, and dining bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7345.jpg"
    },
    {
      "id": "ec_39e9afde75f813d257e83894",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-218d-736e-9e15-5548c74f8893.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and western decor. Includes a pet station with dog bed and bowls.",
        "public_id": "019cfb4b-218d-736e-9e15-5548c74f8893",
        "storage_key": "property/6767906449165639/019cfb4b-218d-736e-9e15-5548c74f8893.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "This bathroom features a stylish vanity with a sink and decorative bull skull accents. Adjacent to the bathroom is a dedicated pet area with a comfortable dog bed and food bowls, showcasing pet-friendly amenities.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror, and western decor. Includes a pet station with dog bed and bowls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7621.jpg"
    },
    {
      "id": "ec_7fb2171442687f4aca4634d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-1ee2-71df-a529-18e76db696d9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower curtain.",
        "public_id": "019cfb4b-1ee2-71df-a529-18e76db696d9",
        "storage_key": "property/6767906449165639/019cfb4b-1ee2-71df-a529-18e76db696d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a clean vanity with ample counter space, a comfortable toilet, and a stylish shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7611.jpg"
    },
    {
      "id": "ec_caf7c95f7b0dd80e1f974762",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-1e93-70f8-80eb-29eae55efd82.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a dark wood dresser, king-size bed, nightstand, and ceiling fan.",
        "public_id": "019cfb4b-1e93-70f8-80eb-29eae55efd82",
        "storage_key": "property/6767906449165639/019cfb4b-1e93-70f8-80eb-29eae55efd82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in the spacious primary bedroom, featuring a king-size bed, ample storage, and a ceiling fan for comfort.",
      "link": "false",
      "alt_text": "Primary bedroom with a dark wood dresser, king-size bed, nightstand, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7364.jpg"
    },
    {
      "id": "ec_4872ae5f37b2f723c3779348",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-2be3-700d-ae89-29d7735138ac.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with blue sofa, coffee table, and dining set.",
        "public_id": "019cfb4b-2be3-700d-ae89-29d7735138ac",
        "storage_key": "property/6767906449165639/019cfb4b-2be3-700d-ae89-29d7735138ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and inviting living and dining area featuring a comfortable blue sofa, a stylish coffee table, and a elegant dining set, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Modern living and dining area with blue sofa, coffee table, and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7192.jpg"
    },
    {
      "id": "ec_4e1c783a62f210ca58ade9d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-2b29-71b4-9980-7317c779a48f.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
        "public_id": "019cfb4b-2b29-71b4-9980-7317c779a48f",
        "storage_key": "property/6767906449165639/019cfb4b-2b29-71b4-9980-7317c779a48f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a king-size bed, elegant decor, and ample natural light. Includes a nightstand, dresser, and ceiling fan for comfort.",
      "link": "false",
      "alt_text": "Primary bedroom with a king-size bed, nightstand, dresser, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7266.jpg"
    },
    {
      "id": "ec_0f0dd85ed79768358669d118",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-2b9f-70e8-bf29-e5b23e4cfac3.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and storage baskets.",
        "public_id": "019cfb4b-2b9f-70e8-bf29-e5b23e4cfac3",
        "storage_key": "property/6767906449165639/019cfb4b-2b9f-70e8-bf29-e5b23e4cfac3.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white wire shelving and decorative storage baskets, perfect for organizing your belongings.",
      "link": "false",
      "alt_text": "Empty walk-in closet with white wire shelving and storage baskets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7412.jpg"
    },
    {
      "id": "ec_424ae464b3cd10f6942e9c0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-316d-776f-907e-6bb3339b558d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and shower with curtain.",
        "public_id": "019cfb4b-316d-776f-907e-6bb3339b558d",
        "storage_key": "property/6767906449165639/019cfb4b-316d-776f-907e-6bb3339b558d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a vanity with a stone-patterned countertop, a sink, a toilet, and a shower with a white tiled wall and a striped shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and shower with curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7256.jpg"
    },
    {
      "id": "ec_4c49e6c02a08ea86fbbb328c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-36fb-7136-9c22-8234675d957b.webp",
      "image_media": {
        "alt_text": "Balcony overlooking a swimming pool and apartment buildings",
        "public_id": "019cfb4b-36fb-7136-9c22-8234675d957b",
        "storage_key": "property/6767906449165639/019cfb4b-36fb-7136-9c22-8234675d957b.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, with views of the sparkling swimming pool and surrounding community.",
      "link": "false",
      "alt_text": "Balcony overlooking a swimming pool and apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7284.jpg"
    },
    {
      "id": "ec_11a9603abbda21edca6616e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-39ed-705b-b1da-fcd6e135f146.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and breakfast bar seating.",
        "public_id": "019cfb4b-39ed-705b-b1da-fcd6e135f146",
        "storage_key": "property/6767906449165639/019cfb4b-39ed-705b-b1da-fcd6e135f146.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample cabinet space, and a spacious island perfect for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and breakfast bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7316.jpg"
    },
    {
      "id": "ec_37e95f9ea9a4941257201e1e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-4121-73fe-8492-3b4ea3afb403.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, couch, coffee table, and desk area.",
        "public_id": "019cfb4b-4121-73fe-8492-3b4ea3afb403",
        "storage_key": "property/6767906449165639/019cfb4b-4121-73fe-8492-3b4ea3afb403.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, comfortable seating, and ample natural light. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with fireplace, couch, coffee table, and desk area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7311.jpg"
    },
    {
      "id": "ec_5443704c7dce92a422cdc1bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-403a-703d-a943-dda9bc73aefd.webp",
      "image_media": {
        "alt_text": "Spacious and modern clubhouse with comfortable seating, a fireplace, and a television.",
        "public_id": "019cfb4b-403a-703d-a943-dda9bc73aefd",
        "storage_key": "property/6767906449165639/019cfb4b-403a-703d-a943-dda9bc73aefd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed clubhouse, featuring elegant seating areas, a cozy fireplace, and a large screen TV for entertainment.",
      "link": "false",
      "alt_text": "Spacious and modern clubhouse with comfortable seating, a fireplace, and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7102.jpg"
    },
    {
      "id": "ec_a7dd7056aea35aad18426480",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-405c-7648-b1b0-93dac51d2822.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with seating, a reception desk, and a coffee bar.",
        "public_id": "019cfb4b-405c-7648-b1b0-93dac51d2822",
        "storage_key": "property/6767906449165639/019cfb4b-405c-7648-b1b0-93dac51d2822.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and connect in our inviting community lounge, featuring comfortable seating, a convenient coffee bar, and a welcoming reception area.",
      "link": "false",
      "alt_text": "Spacious community lounge with seating, a reception desk, and a coffee bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7116.jpg"
    },
    {
      "id": "ec_ab9ace2447bf289b74424fb7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-445b-76ef-a1e4-a9e0b530b6b3.webp",
      "image_media": {
        "alt_text": "Dining room with a table and chairs, large windows with blinds, and white curtains.",
        "public_id": "019cfb4b-445b-76ef-a1e4-a9e0b530b6b3",
        "storage_key": "property/6767906449165639/019cfb4b-445b-76ef-a1e4-a9e0b530b6b3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy dining room featuring a dark wood table with upholstered chairs, large windows with blinds, and elegant white curtains.",
      "link": "false",
      "alt_text": "Dining room with a table and chairs, large windows with blinds, and white curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7340.jpg"
    },
    {
      "id": "ec_4dd1194eb6206b3c8699653d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-40b9-773e-b3aa-fe21c0fef2ed.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white refrigerator, and granite countertops.",
        "public_id": "019cfb4b-40b9-773e-b3aa-fe21c0fef2ed",
        "storage_key": "property/6767906449165639/019cfb4b-40b9-773e-b3aa-fe21c0fef2ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this modern kitchen featuring ample cabinet space, stainless steel appliances, and elegant granite countertops, perfect for any home chef.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white refrigerator, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7207.jpg"
    },
    {
      "id": "ec_e54c2d5d5d92f2cc9ad41dac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-47e2-7407-83f2-56430b91bb1a.webp",
      "image_media": {
        "alt_text": "Spacious living area and kitchen in a modern apartment.",
        "public_id": "019cfb4b-47e2-7407-83f2-56430b91bb1a",
        "storage_key": "property/6767906449165639/019cfb4b-47e2-7407-83f2-56430b91bb1a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this open-concept living and dining area, featuring a fully equipped kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Spacious living area and kitchen in a modern apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7177.jpg"
    },
    {
      "id": "ec_cf292ff277748a6dd4e34de0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-47b1-75ba-9a3c-7466f192025b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana at an apartment complex.",
        "public_id": "019cfb4b-47b1-75ba-9a3c-7466f192025b",
        "storage_key": "property/6767906449165639/019cfb4b-47b1-75ba-9a3c-7466f192025b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool. Enjoy lounging in a cabana or on a comfortable chair, perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7148.jpg"
    },
    {
      "id": "ec_17d70d5e4d03a06b4ae2b642",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-4714-7148-ac7a-35c21afb8eb4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar with two woven stools.",
        "public_id": "019cfb4b-4714-7148-ac7a-35c21afb8eb4",
        "storage_key": "property/6767906449165639/019cfb4b-4714-7148-ac7a-35c21afb8eb4.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring granite countertops, ample cabinet space, and a breakfast bar perfect for casual dining. Includes modern appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar with two woven stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7187(1).jpg"
    },
    {
      "id": "ec_1e3ff21ee0a4e8e7bb52d2a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-4d34-703f-97cb-2a00e4f44af1.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, ellipticals, weight machines, free weights, and medicine balls.",
        "public_id": "019cfb4b-4d34-703f-97cb-2a00e4f44af1",
        "storage_key": "property/6767906449165639/019cfb4b-4d34-703f-97cb-2a00e4f44af1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Modern apartment gym with treadmills, ellipticals, weight machines, free weights, and medicine balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/3772/IMG_7137.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_864f82d1-ed84-498e-bd75-03a49616a327",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Magnolia Table",
      "poi_type": "Restaurants",
      "poi_address": "2132 S Valley Mills Dr, Waco, TX 76706, USA",
      "poi_short_description": "Charming restaurant for familiar fare, such as biscuits, burgers, French toast, tacos and pancakes.",
      "poi_long_description": "People say this American restaurant serves delicious Jo's Chicken Salad Sandwich, avocado toast, and biscuits with strawberry butter. They highlight the generous portions, fresh ingredients, and the fun, cute, and beautiful atmosphere. They also like the attentive staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-9f05-74e5-9a8b-215d4e65d24d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9f05-74e5-9a8b-215d4e65d24d",
        "storage_key": "property/6767906449165639/019d2709-9f05-74e5-9a8b-215d4e65d24d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://magnolia.com/visit/eat/magnolia-table/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15024825786996619514&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "magnolia-table",
      "poi_latitude": "31.5245913",
      "poi_longitude": "-97.1326488",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-265-6859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d0c1-70d7-9ffc-643d56c61981",
        "storage_key": "property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXt4pCuCT4YR-vgPxnLngtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ab71f1ec-b7cb-4e97-a035-e45f91650d47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Terry Black's Barbecue Waco",
      "poi_type": "Restaurants",
      "poi_address": "228 S 8th St, Waco, TX 76701, USA",
      "poi_short_description": "Laid-back locale specializing in brisket and other smoked meats, as well as sides, desserts and drinks.",
      "poi_long_description": "People say this barbecue restaurant serves moist brisket, jalapeño cheese sausage, and tender ribs. They highlight the generous portions, delicious sides, and the spacious indoor and outdoor seating. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-9e5e-77aa-93b0-9f7d27380e2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9e5e-77aa-93b0-9f7d27380e2b",
        "storage_key": "property/6767906449165639/019d2709-9e5e-77aa-93b0-9f7d27380e2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://terryblacksbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5712016703986193757&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "terry-blacks-barbecue-waco",
      "poi_latitude": "31.5532849",
      "poi_longitude": "-97.1325342",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-300-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d0c1-70d7-9ffc-643d56c61981",
        "storage_key": "property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl1hU9QiDT4YRXdUxwO0oRU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b4e121f4-ecaa-4031-8d8a-5ad67a028030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "801 S 4th St, Waco, TX 76706, USA",
      "poi_short_description": "Drive-thru burger chain featuring made-to-order patties, fresh fries and milkshake menu.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, animal style fries, and shakes. They highlight the consistent quality, fast service, and friendly staff. They also like the clean facilities and good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-9edf-7678-9f2c-43d9d5e5bbe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9edf-7678-9f2c-43d9d5e5bbe3",
        "storage_key": "property/6767906449165639/019d2709-9edf-7678-9f2c-43d9d5e5bbe3.webp",
        "width": 1280,
        "height": 680
      },
      "poi_business_url": "https://locations.in-n-out.com/307",
      "poi_directions_map_url": "https://maps.google.com/?cid=12848417709831099316&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "31.5511551",
      "poi_longitude": "-97.1240726",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d0c1-70d7-9ffc-643d56c61981",
        "storage_key": "property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTSSjUWCT4YRtBNSUNW_TrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1e6cffcd-9193-47ad-baad-7341a16d131a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "George’s Restaurant Bar & Catering",
      "poi_type": "Restaurants",
      "poi_address": "1925 Speight Ave, Waco, TX 76706, USA",
      "poi_short_description": "Relaxed, longtime eatery whipping up traditional Southern fare, burgers and steaks, plus Mexican dishes.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, onion rings, and fried pickles. They highlight the generous portions, reasonable prices, and fun, relaxed atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a02a-7150-90c3-ee857b591e4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a02a-7150-90c3-ee857b591e4d",
        "storage_key": "property/6767906449165639/019d2709-a02a-7150-90c3-ee857b591e4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://georgesrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3208701387611377180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georges-restaurant-bar--catering",
      "poi_latitude": "31.53403",
      "poi_longitude": "-97.13197",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-753-1421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d0c1-70d7-9ffc-643d56c61981",
        "storage_key": "property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZu4QDKCT4YRHA7hXumYhyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_3ba8ec8d-d2cb-4463-96c2-58f52c067d64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2815 La Salle Ave, Waco, TX 76706, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Diners say this steak house serves delicious chicken fried chicken, Dallas filet, porterhouse, prime rib, and ribs, with a special shout-out to the rolls. They also highlight the friendly and attentive service, and the reasonable prices.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a422-77b1-9773-aa7fe64fe084.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a422-77b1-9773-aa7fe64fe084",
        "storage_key": "property/6767906449165639/019d2709-a422-77b1-9773-aa7fe64fe084.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/waco?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3955079780772252221&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.5225365",
      "poi_longitude": "-97.1340146",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-662-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d0c1-70d7-9ffc-643d56c61981",
        "storage_key": "property/6767906449165639/019d2709-d0c1-70d7-9ffc-643d56c61981.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSsW7iqCT4YRPYpCDxtE4zY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c07358b9-606a-4396-b8ea-9503c38dcde1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "1821 S Valley Mills Dr, Waco, TX 76711, USA",
      "poi_short_description": "Popular supermarket for grocery staples, organic products, fresh produce and more.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, and baked goods, as well as a hot foods counter. They highlight the fair prices, clean and organized store, and friendly, helpful staff. They also like the convenient curbside pickup and H-E-B app.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a37a-777d-ba84-e1f3e379819a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a37a-777d-ba84-e1f3e379819a",
        "storage_key": "property/6767906449165639/019d2709-a37a-777d-ba84-e1f3e379819a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/waco/valley-mills-h-e-b-plus--672?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=14018785604489557153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "31.5230195",
      "poi_longitude": "-97.1372826",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-710-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d088-719a-9d62-6d0531fcbe85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d088-719a-9d62-6d0531fcbe85",
        "storage_key": "property/6767906449165639/019d2709-d088-719a-9d62-6d0531fcbe85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Y9uC9qDT4YRobT1iTu7jMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_eecf2f7e-c25f-4556-915b-a0bf62e3ce0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Richland Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 W Waco Dr, Waco, TX 76710, USA",
      "poi_short_description": "Loud, clean shopping mall featuring multiple shops and eateries for clothing, electronics and jewelry.",
      "poi_long_description": "Low-key indoor mall with a familiar range of chain retailers & department stores, plus a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a3ff-7458-8657-f73274d988ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a3ff-7458-8657-f73274d988ac",
        "storage_key": "property/6767906449165639/019d2709-a3ff-7458-8657-f73274d988ac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.richlandmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4753002464235028715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richland-mall",
      "poi_latitude": "31.5164049",
      "poi_longitude": "-97.188648",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-776-6631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d09f-77d9-8b8b-84e73a33ad6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d09f-77d9-8b8b-84e73a33ad6e",
        "storage_key": "property/6767906449165639/019d2709-d09f-77d9-8b8b-84e73a33ad6e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2ZnYRqiGT4YR6wBJCY8O9kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4370f139-bcdd-4850-96eb-9233d95378e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "1301 Wooded Acres Dr, Waco, TX 76710, USA",
      "poi_short_description": "Grocery store stocking products from local farmers and suppliers, plus meat, seafood and produce, as well as prepared foods, flowers and a bakery, plus a pharmacy.",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of products at affordable prices, and they praise the fresh produce, delicious bakery items, and top-notch meat selection. They also highlight the friendly and helpful staff, and the clean and well-stocked store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a506-76f8-a935-c9088b8e245d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a506-76f8-a935-c9088b8e245d",
        "storage_key": "property/6767906449165639/019d2709-a506-76f8-a935-c9088b8e245d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/waco/wooded-acres-h-e-b-423?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=9365767768359474083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "31.533912",
      "poi_longitude": "-97.188173",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-776-7040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d088-719a-9d62-6d0531fcbe85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d088-719a-9d62-6d0531fcbe85",
        "storage_key": "property/6767906449165639/019d2709-d088-719a-9d62-6d0531fcbe85.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwX6IQ6ET4YRo5Pe0Snk-YE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f5a3c8b8-71c8-43d0-8f91-7371fff0013a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Baylor University",
      "poi_type": "Education",
      "poi_address": "1311 S 5th St, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a89d-7619-88c9-1ccd6254b32c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a89d-7619-88c9-1ccd6254b32c",
        "storage_key": "property/6767906449165639/019d2709-a89d-7619-88c9-1ccd6254b32c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baylor.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7163770527817390045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baylor-university",
      "poi_latitude": "31.5500848",
      "poi_longitude": "-97.11354",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-229-5678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d07b-70bb-90c3-c5a4b1820558",
        "storage_key": "property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkebHSWqCT4YR3df3-lbTamM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e2880f63-bee8-46d9-915f-7f0498e8e49f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "McLennan Community College",
      "poi_type": "Education",
      "poi_address": "1400 College Dr, Waco, TX 76708, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a981-773f-8345-a50f202041fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a981-773f-8345-a50f202041fc",
        "storage_key": "property/6767906449165639/019d2709-a981-773f-8345-a50f202041fc.webp",
        "width": 1280,
        "height": 1197
      },
      "poi_business_url": "http://www.mclennan.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8969860626952648163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mclennan-community-college",
      "poi_latitude": "31.5889679",
      "poi_longitude": "-97.1726265",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 254-299-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d07b-70bb-90c3-c5a4b1820558",
        "storage_key": "property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUtYSVyDT4YR43VGQrdYe3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ddb0afe5-8358-411a-99b9-ef28e7657cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Moody Memorial Library",
      "poi_type": "Education",
      "poi_address": "1312 S 3rd St, Waco, TX 76798, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-a9f9-7084-a15d-ecbe7c6656e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a9f9-7084-a15d-ecbe7c6656e5",
        "storage_key": "property/6767906449165639/019d2709-a9f9-7084-a15d-ecbe7c6656e5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.baylor.edu/library/moodyjones",
      "poi_directions_map_url": "https://maps.google.com/?cid=7800864692600987949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moody-memorial-library",
      "poi_latitude": "31.5488251",
      "poi_longitude": "-97.1177558",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-710-6702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d476-703d-9a27-fcaecaf9fa97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d476-703d-9a27-fcaecaf9fa97",
        "storage_key": "property/6767906449165639/019d2709-d476-703d-9a27-fcaecaf9fa97.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpa7dQ0GCT4YRLWFebxs9Qmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_9b4e0ca0-f354-440c-ad51-76c8ceb5bee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Waco-McLennan County Library Central Library",
      "poi_type": "Education",
      "poi_address": "1717 Austin Ave, Waco, TX 76701, USA",
      "poi_short_description": "Public library with indoor and outdoor seating offering books, movies, and a variety of materials to borrow.",
      "poi_long_description": "People say this public library offers a wide selection of books, media, services, and activities, including \"touch a truck\" events. They highlight the pleasant atmosphere and the helpful, sweet, and kind staff. They also like the quiet and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-aa3d-761e-b563-ae2f403f9356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aa3d-761e-b563-ae2f403f9356",
        "storage_key": "property/6767906449165639/019d2709-aa3d-761e-b563-ae2f403f9356.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.wacolibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17865099954342392677&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-mclennan-county-library-central-library",
      "poi_latitude": "31.5467586",
      "poi_longitude": "-97.1437399",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-750-5941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d07b-70bb-90c3-c5a4b1820558",
        "storage_key": "property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmatj47aDT4YRZfNsT8GV7fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_473c5f56-e8b7-49c0-8f44-1aa38370b4ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Dr Pepper Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 S 5th St, Waco, TX 76701, USA",
      "poi_short_description": "Museum in downtown showcasing the history of Dr Pepper, a soft drink.",
      "poi_long_description": "People say this museum offers a self-guided tour with informative exhibits, memorabilia, and a soda fountain where visitors can enjoy a free drink or purchase floats. They also highlight the reasonable admission price, the interactive soda-making experience, and the friendly staff.\n\nOther reviews mention the museum can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-af1a-75bb-9ed3-15f3094a4005.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-af1a-75bb-9ed3-15f3094a4005",
        "storage_key": "property/6767906449165639/019d2709-af1a-75bb-9ed3-15f3094a4005.webp",
        "width": 1280,
        "height": 712
      },
      "poi_business_url": "http://www.drpeppermuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11954819412563611991&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dr-pepper-museum",
      "poi_latitude": "31.5551583",
      "poi_longitude": "-97.1295999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-757-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4e5-77cf-8c80-26240009f9f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4e5-77cf-8c80-26240009f9f2",
        "storage_key": "property/6767906449165639/019d2709-d4e5-77cf-8c80-26240009f9f2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOakuHk6CT4YRV1HMl-oM6KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f663c469-ce99-4fa8-ad81-25450bf4c94c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Cameron Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1701 N 4th St, Waco, TX 76707, USA",
      "poi_short_description": "Midsize zoo, with a cafe, featuring native wildlife, including African species and lemurs, plus a playground, water stations, wall-less enclosures, and a gift shop.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including lions, giraffes, elephants, rhinos, otters, and penguins, with many indoor exhibits and shaded pathways. They highlight the spacious layout, well-maintained enclosures, and family-friendly atmosphere, as well as the worthwhile membership option. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-ae98-763b-8caf-68ffeb525257.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ae98-763b-8caf-68ffeb525257",
        "storage_key": "property/6767906449165639/019d2709-ae98-763b-8caf-68ffeb525257.webp",
        "width": 960,
        "height": 422
      },
      "poi_business_url": "http://www.cameronparkzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13803951944348861414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cameron-park-zoo",
      "poi_latitude": "31.5701472",
      "poi_longitude": "-97.1445667",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-750-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSJ7CQaDT4YR5gN6Kyh9kb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_de7960d2-bf17-4c5d-a887-49f3fcc5fba4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "McLane Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1001 S M.L.K. Jr Blvd, Waco, TX 76704, USA",
      "poi_short_description": "Sports stadium featuring clean restrooms, food and drink sold at various outlets, as well as modern amenities, such as tailgating.",
      "poi_long_description": "Fans say this stadium is a great place to watch the Baylor Bears play football, and they appreciate the free water stations, plentiful restrooms, and easy access. They also highlight the friendly and helpful staff, as well as the respectful and hospitable Baylor fans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-af4a-767d-9660-5885cc25760e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-af4a-767d-9660-5885cc25760e",
        "storage_key": "property/6767906449165639/019d2709-af4a-767d-9660-5885cc25760e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mclanestadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=948108573633282188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mclane-stadium",
      "poi_latitude": "31.5582015",
      "poi_longitude": "-97.1156702",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-710-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d571-7438-92b4-3da848eac8c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d571-7438-92b4-3da848eac8c4",
        "storage_key": "property/6767906449165639/019d2709-d571-7438-92b4-3da848eac8c4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLRpHmF2CT4YRjADqc7lbKA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_17c953a4-6577-49c0-be49-28d9bb00a1b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Mayborn Museum Complex",
      "poi_type": "Entertainment",
      "poi_address": "1300 S University Parks Dr, Waco, TX 76706, USA",
      "poi_short_description": "Vast museum with hands-on exhibits exploring local cultural history and natural science.",
      "poi_long_description": "People say this museum offers a wide variety of interactive exhibits and activities, including a popular bubble room, suitable for children and adults. They highlight the educational and fun experience, and the opportunity to learn about local history and culture. They also like the friendly and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-aeed-7711-a5b5-989f06833adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aeed-7711-a5b5-989f06833adb",
        "storage_key": "property/6767906449165639/019d2709-aeed-7711-a5b5-989f06833adb.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.baylor.edu/mayborn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3457497109688938317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mayborn-museum-complex",
      "poi_latitude": "31.5518639",
      "poi_longitude": "-97.11499200000002",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-710-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4e5-77cf-8c80-26240009f9f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4e5-77cf-8c80-26240009f9f2",
        "storage_key": "property/6767906449165639/019d2709-d4e5-77cf-8c80-26240009f9f2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ63G-TEKCT4YRTe_yek1_-y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bf7db4e4-c4b8-4ffe-b88b-8cf151dac533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Texas Ranger Hall of Fame & Museum",
      "poi_type": "Entertainment",
      "poi_address": "100 Texas Ranger Trail, Waco, TX 76706, USA",
      "poi_short_description": "Clean museum detailing the Texas Rangers and their weapons, with memorabilia, photographs, and paintings.",
      "poi_long_description": "People say this heritage museum offers a fascinating collection of artifacts, memorabilia, and exhibits showcasing the history of the Texas Rangers. They highlight the informative scavenger hunt, the interesting movie, and the well-curated displays. They also like the friendly staff and the reasonably priced gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b377-773f-9cf4-9b13db2f6d14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b377-773f-9cf4-9b13db2f6d14",
        "storage_key": "property/6767906449165639/019d2709-b377-773f-9cf4-9b13db2f6d14.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.texasranger.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=868283811813356774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-ranger-hall-of-fame--museum",
      "poi_latitude": "31.5555471",
      "poi_longitude": "-97.1187182",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-750-8631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4e5-77cf-8c80-26240009f9f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4e5-77cf-8c80-26240009f9f2",
        "storage_key": "property/6767906449165639/019d2709-d4e5-77cf-8c80-26240009f9f2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6rUSkOCT4YR5nRbx4bDDAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_361269c5-9a16-4210-adac-662f0d7cf7ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "300 N Valley Mills Dr, Waco, TX 76710, USA",
      "poi_short_description": "Chain of clean, down-to-earth gyms featuring cardio equipment, locker rooms and tanning machines.",
      "poi_long_description": "People say this gym offers a wide selection of equipment and supplements. They highlight the clean and well-maintained facilities, and the welcoming and non-intimidating atmosphere. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b31b-70ba-b894-855aaa722ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b31b-70ba-b894-855aaa722ba9",
        "storage_key": "property/6767906449165639/019d2709-b31b-70ba-b894-855aaa722ba9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/waco-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4080706577757134135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.52663759999999",
      "poi_longitude": "-97.166908",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-224-5203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYZg6-SDT4YRN13QDwOVoTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4cab6716-7b8d-49df-918a-e75c70b520df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Crunch Fitness - Waco",
      "poi_type": "Health and Wellness",
      "poi_address": "575 N Valley Mills Dr, Waco, TX 76710, USA",
      "poi_short_description": "Chain fitness center offering classes, weights and machines.",
      "poi_long_description": "People say this gym offers a large variety of well-maintained equipment and a tanning area with clean tanning beds. They also highlight the friendly and helpful staff, and the welcoming and professional vibe.\n\nOther reviews mention the gym can be crowded during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b3f1-734c-ad19-eb75e5e47115.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b3f1-734c-ad19-eb75e5e47115",
        "storage_key": "property/6767906449165639/019d2709-b3f1-734c-ad19-eb75e5e47115.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/waco",
      "poi_directions_map_url": "https://maps.google.com/?cid=1072343148433953578&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---waco",
      "poi_latitude": "31.529965",
      "poi_longitude": "-97.1730913",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-265-8265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-4e4W2DT4YRKtO6d2m64Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a8d94c7d-6711-44eb-923e-e3acb08b8a30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2432 W Loop 340 Ste A, Waco, TX 76711, USA",
      "poi_short_description": "Chain featuring a wide variety of makeup, skincare and hair care products.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b395-7068-9b29-d827c12dc4b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b395-7068-9b29-d827c12dc4b7",
        "storage_key": "property/6767906449165639/019d2709-b395-7068-9b29-d827c12dc4b7.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/waco-tx-1046",
      "poi_directions_map_url": "https://maps.google.com/?cid=10808879544046475121&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "31.498442",
      "poi_longitude": "-97.1595883",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-662-9117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIYcxo-6BT4YRcVfgaq3aAJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_60efb7f2-3658-4016-bb2e-34c3fe4669b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Animal Birth Control Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3238 Clay Ave, Waco, TX 76711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b828-76a9-9f58-cd319c55ad4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b828-76a9-9f58-cd319c55ad4f",
        "storage_key": "property/6767906449165639/019d2709-b828-76a9-9f58-cd319c55ad4f.webp",
        "width": 1280,
        "height": 1011
      },
      "poi_business_url": "http://www.animalbirthcontrol.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9491659999051597985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-birth-control-clinic",
      "poi_latitude": "31.5277316",
      "poi_longitude": "-97.1531023",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-776-7303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d85d-707a-921f-33f72a0e115b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d85d-707a-921f-33f72a0e115b",
        "storage_key": "property/6767906449165639/019d2709-d85d-707a-921f-33f72a0e115b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5a7aNyDT4YRoUhB7HomuYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_746ed4b7-e09f-42a6-9acf-c5895bbc61cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Butler's Barber Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "1521 Wooded Acres Dr Suite A, Waco, TX 76710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b90d-7433-9ee0-7469a1c6a91d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b90d-7433-9ee0-7469a1c6a91d",
        "storage_key": "property/6767906449165639/019d2709-b90d-7433-9ee0-7469a1c6a91d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.butlersbarberlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16256636256258416199&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "butlers-barber-lounge",
      "poi_latitude": "31.5353565",
      "poi_longitude": "-97.1905059",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-224-6781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRBtStKFT4YRR94EMYssm-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_3ced8b82-9b12-4eca-92d0-6d384bfa131f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Waco Regional Tennis & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "900 Lake Shore Dr, Waco, TX 76708, USA",
      "poi_short_description": "Clean spot for tennis players, with 19 outdoor courts and 20 overall, plus pickleball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b838-76ec-ae8c-dfda6a4e935f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b838-76ec-ae8c-dfda6a4e935f",
        "storage_key": "property/6767906449165639/019d2709-b838-76ec-ae8c-dfda6a4e935f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wacotennis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14886065552257760890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-regional-tennis--fitness-center",
      "poi_latitude": "31.5953503",
      "poi_longitude": "-97.1670493",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 254-753-7675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4MR2ESDT4YRer6AAcDtlc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_47f88b07-c9d0-4691-abdc-91f71bde5f52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "McLane Student Life Center- SLC",
      "poi_type": "Health and Wellness",
      "poi_address": "McLane Student Life Center, 209 Speight Ave, Waco, TX 76706, USA",
      "poi_short_description": "Recreation center featuring basketball and racquetball courts, a pool, and a weight room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-b8ed-77cb-8ad2-a946a248fbd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b8ed-77cb-8ad2-a946a248fbd2",
        "storage_key": "property/6767906449165639/019d2709-b8ed-77cb-8ad2-a946a248fbd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.baylor.edu/campusrec/index.php?id=928396",
      "poi_directions_map_url": "https://maps.google.com/?cid=5921233752644781204&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mclane-student-life-center--slc",
      "poi_latitude": "31.5473935",
      "poi_longitude": "-97.1141152",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-710-7542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkaSygGqCT4YRlARy2rlyLFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_41d5ffcf-3a63-4d8f-9c0a-0a9cbe083f3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Texas Dynasty Cheer & Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Schroeder Dr Suite C, Waco, TX 76710, USA",
      "poi_short_description": "Spacious venue for gymnastics and cheerleading, featuring classes and parties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-bd72-778b-a9c2-1539b4aa8381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bd72-778b-a9c2-1539b4aa8381",
        "storage_key": "property/6767906449165639/019d2709-bd72-778b-a9c2-1539b4aa8381.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://txdynasty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10922492512142983377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-dynasty-cheer--gymnastics",
      "poi_latitude": "31.51086889999999",
      "poi_longitude": "-97.173836",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-776-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d07b-70bb-90c3-c5a4b1820558",
        "storage_key": "property/6767906449165639/019d2709-d07b-70bb-90c3-c5a4b1820558.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoxbCvqqGT4YR0YAl6BF9lJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bc2d721c-81d8-4700-818a-7418db6313fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Waco Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Jack Kultgen Fwy, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-bd39-723b-b0c2-5885fb9d3b3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bd39-723b-b0c2-5885fb9d3b3b",
        "storage_key": "property/6767906449165639/019d2709-bd39-723b-b0c2-5885fb9d3b3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wacoanimalemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742041022524351834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-animal-emergency-clinic",
      "poi_latitude": "31.5114638",
      "poi_longitude": "-97.1418971",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-752-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWX0LXqBT4YRWuUQeEpBcWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3fe2a679-27fe-4bd8-b03f-351ed8ce62fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Southern Swings Nail & Wine Bar Waco",
      "poi_type": "Health and Wellness",
      "poi_address": "501 S 8th St, Waco, TX 76706, USA",
      "poi_short_description": "Nail and beauty salon, featuring swinging chairs for pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-be29-741c-8000-ce2784f2fc82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-be29-741c-8000-ce2784f2fc82",
        "storage_key": "property/6767906449165639/019d2709-be29-741c-8000-ce2784f2fc82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.southernswingsnailbarwaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7160261195025307661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-swings-nail--wine-bar-waco",
      "poi_latitude": "31.5509934",
      "poi_longitude": "-97.1305695",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-294-8241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UP5L3yDT4YRDVh_xJ5bXmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_578f2dab-aad6-4e31-b690-9f3c29de9807",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Baylor Scott & White Medical Center - Hillcrest",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Hillcrest Medical Blvd, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-bdaa-7516-99dc-509d7407deda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bdaa-7516-99dc-509d7407deda",
        "storage_key": "property/6767906449165639/019d2709-bdaa-7516-99dc-509d7407deda.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/hillcrest?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8216934832998146127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baylor-scott--white-medical-center---hillcrest",
      "poi_latitude": "31.4890068",
      "poi_longitude": "-97.1576836",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d868-72d5-a213-04fa8662189a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d868-72d5-a213-04fa8662189a",
        "storage_key": "property/6767906449165639/019d2709-d868-72d5-a213-04fa8662189a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaGo4T2BT4YRT2BjB7JqCHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0e3a8e35-2bf3-4a0d-aa06-8da897a85196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Ascension Providence Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6901 Medical Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c23b-711f-8e55-ac52b3713fec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c23b-711f-8e55-ac52b3713fec",
        "storage_key": "property/6767906449165639/019d2709-c23b-711f-8e55-ac52b3713fec.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/texas/txwac/waco-ascension-providence-hospital?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6492679134749646913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-providence-hospital",
      "poi_latitude": "31.5140801",
      "poi_longitude": "-97.1995063",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-751-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d868-72d5-a213-04fa8662189a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d868-72d5-a213-04fa8662189a",
        "storage_key": "property/6767906449165639/019d2709-d868-72d5-a213-04fa8662189a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRliM6CGT4YRQeBX-0WhGlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5190a7dd-c4a4-44de-934c-cd83bf85c01d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Cameron Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2601 N University Parks Dr, Waco, TX 76708, USA",
      "poi_short_description": "Large, dog-friendly zoo and park featuring disc golf courses along with hiking and biking trails through the woods.",
      "poi_long_description": "People say this city park offers a variety of activities, including disc golf, hiking, biking, and playgrounds. They highlight the vast trail network, scenic views of the Brazos River, and well-maintained facilities, such as restrooms and pavilions. They also like the diverse options, from challenging trails to family-friendly areas with splash pads and picnic spots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c248-7179-98c5-09db8cb4a067.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c248-7179-98c5-09db8cb4a067",
        "storage_key": "property/6767906449165639/019d2709-c248-7179-98c5-09db8cb4a067.webp",
        "width": 1280,
        "height": 998
      },
      "poi_business_url": "https://www.waco-texas.com/Departments/Parks-Recreation/Cameron-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1509339208401902560&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cameron-park",
      "poi_latitude": "31.5836578",
      "poi_longitude": "-97.1562575",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 254-750-5980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d8ce-77f7-b00d-29956a87b298",
        "storage_key": "property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5jISRODT4YR4FtdYgNA8hQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_446fb85d-1820-4d76-9f8d-a426c9137968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Cottonwood Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Bagby Ave, Waco, TX 76711, USA",
      "poi_short_description": "Tract featuring a driving range as well as 3- and 18-hole courses, plus friendly service.",
      "poi_long_description": "Casual public course with a pro shop stocking golf gear & accessories, plus club fittings & repairs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c21e-74dc-93b9-924449ccf6a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c21e-74dc-93b9-924449ccf6a1",
        "storage_key": "property/6767906449165639/019d2709-c21e-74dc-93b9-924449ccf6a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.waco-texas.com/cottonwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=2026844058063726421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cottonwood-creek-golf-course",
      "poi_latitude": "31.5064126",
      "poi_longitude": "-97.1617916",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-745-6009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-da77-75d0-baa8-c5c798598382.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-da77-75d0-baa8-c5c798598382",
        "storage_key": "property/6767906449165639/019d2709-da77-75d0-baa8-c5c798598382.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7hY4kKBT4YRVef_n-7LIBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5ec115fb-3011-456a-aef0-9db4c17e6429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Woodway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1625 Estates Dr, Woodway, TX 76712, USA",
      "poi_short_description": "Park with a disc golf course, trails, fishing, and picnic tables, plus a peaceful lake.",
      "poi_long_description": "Visitors say this city park offers scenic hiking trails through the woods and along the lake shore, with opportunities for disc golf, picnics, and enjoying the sunset. They also highlight the park's clean and quiet atmosphere, perfect for relaxing, exercising, or spending time with family and pets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c329-74b5-9393-c4db423ee51a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c329-74b5-9393-c4db423ee51a",
        "storage_key": "property/6767906449165639/019d2709-c329-74b5-9393-c4db423ee51a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverwoodway.com/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2535205004088397821&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodway-park",
      "poi_latitude": "31.5222564",
      "poi_longitude": "-97.2338532",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-772-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d8ce-77f7-b00d-29956a87b298",
        "storage_key": "property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu45KvHuGT4YR_U975YTbLiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_83518bf8-0cb4-4bd9-9c84-eccbd1799133",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Jacob's Ladder",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 Cameron Park Dr, Waco, TX 76708, USA",
      "poi_short_description": "Park with picnic tables and a popular set of stairs providing a workout and scenic views.",
      "poi_long_description": "People say this park offers a challenging climb up steep, uneven steps, and beautiful scenery along the river. They highlight the unique and rewarding experience, and the playground, fountain, and garden at the top. They also like the opportunity to connect with nature and enjoy a scenic walk.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c750-7510-996f-671a3fc34d73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c750-7510-996f-671a3fc34d73",
        "storage_key": "property/6767906449165639/019d2709-c750-7510-996f-671a3fc34d73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.waco-texas.com/Departments/Parks-Recreation/Cameron-Park/Cameron-Park-Points-of-Interest",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046674195203821189&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacobs-ladder",
      "poi_latitude": "31.577538",
      "poi_longitude": "-97.1493446",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-750-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d8ce-77f7-b00d-29956a87b298",
        "storage_key": "property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2aBLRCDT4YRhQ5BLnFjCUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8b741a33-23b3-47e1-b892-3282c46bf4f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Carleen Bright Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9001 Bosque Blvd b, Woodway, TX 76712, USA",
      "poi_short_description": "Well-kept, 16-acre place featuring a playground, splash pads, trails and gardens.",
      "poi_long_description": "People say this arboretum offers peaceful walking trails and relaxing areas to sit and enjoy the scenery. They highlight the calming and organized atmosphere, and the opportunity for birdwatching and photography. They also like that it's free.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c77a-766e-b0ca-09d1466214d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c77a-766e-b0ca-09d1466214d0",
        "storage_key": "property/6767906449165639/019d2709-c77a-766e-b0ca-09d1466214d0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://discoverwoodway.com/arboretum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17033175476687828014&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "carleen-bright-arboretum",
      "poi_latitude": "31.509655",
      "poi_longitude": "-97.230204",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-399-9204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d8ce-77f7-b00d-29956a87b298",
        "storage_key": "property/6767906449165639/019d2709-d8ce-77f7-b00d-29956a87b298.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmd1xfHmGT4YRLnTftNn-Yew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_65b19a72-2418-4d7a-a689-093f639685b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Waco City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Austin Ave, Waco, TX 76702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c7f4-7219-adfa-e01dc76ee8ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c7f4-7219-adfa-e01dc76ee8ea",
        "storage_key": "property/6767906449165639/019d2709-c7f4-7219-adfa-e01dc76ee8ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.waco-texas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8267798876937024994&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-city-hall",
      "poi_latitude": "31.5587515",
      "poi_longitude": "-97.1295862",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-750-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d476-703d-9a27-fcaecaf9fa97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d476-703d-9a27-fcaecaf9fa97",
        "storage_key": "property/6767906449165639/019d2709-d476-703d-9a27-fcaecaf9fa97.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwz9QVGCT4YR4nU0HkYfvXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_6c79483e-08ed-4972-a346-500112728f82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Brazos River Authority",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4600 Cobbs Dr, Waco, TX 76710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-c7c5-726f-b485-5319338e7e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c7c5-726f-b485-5319338e7e93",
        "storage_key": "property/6767906449165639/019d2709-c7c5-726f-b485-5319338e7e93.webp",
        "width": 1280,
        "height": 912
      },
      "poi_business_url": "http://brazos.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8815088014222255767&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brazos-river-authority",
      "poi_latitude": "31.5448822",
      "poi_longitude": "-97.1919947",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-761-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQenhG2ET4YRl2aFN9h7VXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e24aa92a-9679-4c63-9212-7debe2c726e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "La Puerta Waco",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Clay Ave, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-cc55-770c-8a3d-6ff21b726350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cc55-770c-8a3d-6ff21b726350",
        "storage_key": "property/6767906449165639/019d2709-cc55-770c-8a3d-6ff21b726350.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lapuertawaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12772518668909505718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-puerta-waco",
      "poi_latitude": "31.5526836",
      "poi_longitude": "-97.127919",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-301-4062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZd-qk-CT4YRtmxlww4aQbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f515407d-0c7b-45bc-88b0-4bd9afe43512",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Cornerstone Caregiving - Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2612 Washington Ave, Waco, TX 76710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-cc47-766c-8e5e-3bcca053b120.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cc47-766c-8e5e-3bcca053b120",
        "storage_key": "property/6767906449165639/019d2709-cc47-766c-8e5e-3bcca053b120.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://cornerstonecaregiving.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6258200559351579776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cornerstone-caregiving---corporate-office",
      "poi_latitude": "31.53991959999999",
      "poi_longitude": "-97.1524871",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-410-2570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5h4HZODT4YRgERNWUCY2VY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bf3a9512-73f2-44df-8fb9-069c46d11e10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "LaSalle Finance Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2320 La Salle Ave, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17635207458665694283&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lasalle-finance-company",
      "poi_latitude": "31.5258681",
      "poi_longitude": "-97.1287217",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-d4da-74b9-aa16-6c767ac2b776",
        "storage_key": "property/6767906449165639/019d2709-d4da-74b9-aa16-6c767ac2b776.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2axRNVSDT4YRS4QWkr_XvPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c86c66b2-2837-4180-b8a7-18d44363c2c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Kendrick Elementary School",
      "poi_type": "Education",
      "poi_address": "1801 Kendrick Ln, Waco, TX 76711, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wacoisd.org/Page/37",
      "poi_directions_map_url": "https://maps.google.com/?cid=2029444275414086621&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kendrick-elementary-school",
      "poi_latitude": "31.5142934",
      "poi_longitude": "-97.1496145",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-752-3316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb36-703c-b7b6-5c49e3d96753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb36-703c-b7b6-5c49e3d96753",
        "storage_key": "property/6767906449165639/019cfb4b-cb36-703c-b7b6-5c49e3d96753.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD0nKgGSBT4YR3bOB59AIKhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_676d005a-1c69-428a-a206-7d6a15a79922",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Tennyson Middle School",
      "poi_type": "Education",
      "poi_address": "6100 Tennyson Dr, Waco, TX 76710, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-833a-7299-b8cd-cc6e41027939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-833a-7299-b8cd-cc6e41027939",
        "storage_key": "property/6767906449165639/019d7913-833a-7299-b8cd-cc6e41027939.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wacoisd.org/Page/55",
      "poi_directions_map_url": "https://maps.google.com/?cid=16728010994292389162&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tennyson-middle-school",
      "poi_latitude": "31.5240512",
      "poi_longitude": "-97.1944197",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-772-1440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb36-703c-b7b6-5c49e3d96753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb36-703c-b7b6-5c49e3d96753",
        "storage_key": "property/6767906449165639/019cfb4b-cb36-703c-b7b6-5c49e3d96753.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_cZq7xuET4YRKnWg2V7VJeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3fe9ac6f-f22a-419f-a54d-06057cdae799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Waco High School",
      "poi_type": "Education",
      "poi_address": "GRR7+JQ, 2020 N 42nd St, Waco, TX 76710, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-83d3-76e3-afe6-6d6981534c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-83d3-76e3-afe6-6d6981534c6d",
        "storage_key": "property/6767906449165639/019d7913-83d3-76e3-afe6-6d6981534c6d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://whs.wacoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10394912467264859738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waco-high-school",
      "poi_latitude": "31.5428737",
      "poi_longitude": "-97.1846287",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-776-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb36-703c-b7b6-5c49e3d96753.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb36-703c-b7b6-5c49e3d96753",
        "storage_key": "property/6767906449165639/019cfb4b-cb36-703c-b7b6-5c49e3d96753.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ69CBj3OET4YRWu6ZetAlQpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_89dda261-7c01-445c-945b-cfb6e55b0b19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "4109 S Jack Kultgen Expy, Waco, TX 76706, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "People say this breakfast restaurant serves delicious omelets and pancakes, and the coffee is good.\n\nOther reviews mention the service can be slow and the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-861c-718e-85b4-5011558cc36a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-861c-718e-85b4-5011558cc36a",
        "storage_key": "property/6767906449165639/019d7913-861c-718e-85b4-5011558cc36a.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/tx/waco/breakfast-4109-south-jack-kultgen-expy-3001?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=3001&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=18172976995322739790&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "31.5091383",
      "poi_longitude": "-97.1435632",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-757-1133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YwNvnCBT4YRTryO7UpiM_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_b62ca005-c444-413b-b1cf-6b399c1b834e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Our Breakfast Place",
      "poi_type": "Restaurants",
      "poi_address": "4600 Franklin Ave #100, Waco, TX 76710, USA",
      "poi_short_description": "Bright, upbeat diner with a juice bar specializing in breakfast staples & lunch combos.",
      "poi_long_description": "People say this breakfast restaurant serves delicious pancakes, avocado toast, and breakfast bowls. They highlight the generous portions, fair prices, and quick service. They also like the friendly staff and welcoming atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-84aa-763d-a3cc-bd4f458a3d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-84aa-763d-a3cc-bd4f458a3d5b",
        "storage_key": "property/6767906449165639/019d7913-84aa-763d-a3cc-bd4f458a3d5b.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "https://ourbreakfastplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17037091675495190162&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "our-breakfast-place",
      "poi_latitude": "31.5210036",
      "poi_longitude": "-97.1699068",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-399-0886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9HgG_2DT4YRks6ny5zob-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_4727c75b-31e0-4627-96b9-9dbfb63c1478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Logan's Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2806 W Loop 340, Waco, TX 76711, USA",
      "poi_short_description": "Down-to-earth chain offering American standards like burgers & ribs, plus signature cocktails.",
      "poi_long_description": "People say this steakhouse offers delicious steaks, chicken fried steak, and salmon, and the rolls are a highlight.\n\nOther reviews mention the food can be overcooked and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-9301-770b-b57b-03596cb135c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9301-770b-b57b-03596cb135c5",
        "storage_key": "property/6767906449165639/019d7913-9301-770b-b57b-03596cb135c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://logansroadhouse.com/locations/us/tx/waco/2806-west-loop-340/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11689649331734501861&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "logan-s-roadhouse",
      "poi_latitude": "31.496031",
      "poi_longitude": "-97.1528819",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-662-2036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xXYuhSBT4YR5dnq_iH6OaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2ecaed91-9a24-424c-a2df-888b007c1866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Fish City Grill",
      "poi_type": "Restaurants",
      "poi_address": "5401 Crosslake Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "Easygoing chain outpost dishing up Southern-style seafood with daily chalkboard specials.",
      "poi_long_description": "People say this seafood restaurant serves delicious catfish, oysters, and fish and chips. They highlight the reasonable prices, unpretentious atmosphere, and friendly staff. They also like the attentive service and the manager's kindness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-9262-76bd-90e7-e9d67bb5ad89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9262-76bd-90e7-e9d67bb5ad89",
        "storage_key": "property/6767906449165639/019d7913-9262-76bd-90e7-e9d67bb5ad89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fishcitygrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=29384152992130675&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fish-city-grill",
      "poi_latitude": "31.4937072",
      "poi_longitude": "-97.1578951",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-339-1063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1FV9ceBT4YRcyYfQbtkaAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_d97486aa-799b-45f7-a130-87fe0085a2e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "5600 Legend Lake Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, appetizers, and drinks. They also highlight the attentive service, pleasant atmosphere, and reasonable prices.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-922b-772b-8433-4575fba430c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-922b-772b-8433-4575fba430c2",
        "storage_key": "property/6767906449165639/019d7913-922b-772b-8433-4575fba430c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-waco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2937733678232875818&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "31.4936305",
      "poi_longitude": "-97.1594359",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-420-0067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3-htj-BT4YRKrPFLzftxCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_1d3eb4f0-3a6d-402d-88e3-818101ed0836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "5501 Legend Lake Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves flavorful fajitas, cheese enchiladas, and Chuy-Changas. They also highlight the fun atmosphere, affordable prices, and great margaritas.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-9aca-729f-9854-72d6ce81b511.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9aca-729f-9854-72d6ce81b511",
        "storage_key": "property/6767906449165639/019d7913-9aca-729f-9854-72d6ce81b511.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chuys.com/locations/tx/waco/waco-tx/6016?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:waco-tx-6016_pl:locurl_rd:1015",
      "poi_directions_map_url": "https://maps.google.com/?cid=16889027093936889792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuy-s",
      "poi_latitude": "31.495272",
      "poi_longitude": "-97.159275",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-420-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM9gvrD-BT4YRwF8O-KjgYeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_ac398bda-21af-465d-8925-8bd23a9df3c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Central Texas Marketplace",
      "poi_type": "Restaurants",
      "poi_address": "2400 W Loop 340, Waco, TX 76711, USA",
      "poi_short_description": "Shopping center featuring specialty shops and eateries, plus parking.",
      "poi_long_description": "People say this shopping center offers a wide selection of stores, including clothing, outdoor goods, and restaurants. They highlight the convenient location near hotels and Baylor University, and the ample parking. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-9f6c-74b9-a286-72685c64bb3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9f6c-74b9-a286-72685c64bb3c",
        "storage_key": "property/6767906449165639/019d7913-9f6c-74b9-a286-72685c64bb3c.webp",
        "width": 1280,
        "height": 337
      },
      "poi_business_url": "https://amzn.to/3HKyLbO",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038514282824941598&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-texas-marketplace",
      "poi_latitude": "31.4974622",
      "poi_longitude": "-97.1568051",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-265-5255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-5839d2f38586.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-5839d2f38586",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-5839d2f38586.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJm8_xx2qBT4YRHkB3zI33T4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d9fd0d77-07a7-4f81-a94e-ed5afde1b226",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Heart of Texas Goodwill - Waco New Road",
      "poi_type": "Restaurants",
      "poi_address": "1700 S New Rd, Waco, TX 76711, USA",
      "poi_short_description": "Long-standing nonprofit chain with a range of pre-owned clothing, housewares & more.",
      "poi_long_description": "People say this thrift store offers a wide variety of items and a large selection of clothing. They also highlight the prices can be fair and the 50% off color days are a bonus.\n\nOther reviews mention the quality of merchandise can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-9e4a-777c-b6f2-977baf9c98e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9e4a-777c-b6f2-977baf9c98e0",
        "storage_key": "property/6767906449165639/019d7913-9e4a-777c-b6f2-977baf9c98e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hotgoodwill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4807144593244882803&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heart-of-texas-goodwill-waco-new-road",
      "poi_latitude": "31.5101737",
      "poi_longitude": "-97.1562336",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-753-7337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-5839d2f38586.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-5839d2f38586",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-5839d2f38586.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9wMEo2eBT4YRcwdNyIlotkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_f35050de-5e7c-4ad1-84f7-0cb50762cc14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Brazos Place Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "Waco, TX 76710, USA",
      "poi_short_description": "Shopping mall with a variety of stores, including a bookstore and restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-a8b6-72f9-9a13-dac38a99b4cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a8b6-72f9-9a13-dac38a99b4cc",
        "storage_key": "property/6767906449165639/019d7913-a8b6-72f9-9a13-dac38a99b4cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18140347742399636521&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brazos-place-shopping-center",
      "poi_latitude": "31.5268041",
      "poi_longitude": "-97.1704589",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-5839d2f38586.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-5839d2f38586",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-5839d2f38586.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI6JHkIuDT4YRKSTK9yh2v_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_591fb806-a621-4e16-be86-1ca87f365fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Magnolia Market Guest Parking",
      "poi_type": "Restaurants",
      "poi_address": "416 S 9th St, Waco, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-aa14-70ee-937f-40ce0e00eb23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-aa14-70ee-937f-40ce0e00eb23",
        "storage_key": "property/6767906449165639/019d7913-aa14-70ee-937f-40ce0e00eb23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://magnolia.com/visit",
      "poi_directions_map_url": "https://maps.google.com/?cid=8112546235333384861&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "magnolia-market-guest-parking",
      "poi_latitude": "31.5508086",
      "poi_longitude": "-97.1313811",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-c199-7638-b818-3dc475b50bf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-c199-7638-b818-3dc475b50bf6",
        "storage_key": "property/6767906449165639/019d7913-c199-7638-b818-3dc475b50bf6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9X_nabCDT4YRnZr6pNGNlXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_4f54ffc0-cd44-4d00-98b7-c346b027ba6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Cinemark Waco and XD",
      "poi_type": "Entertainment",
      "poi_address": "2400 Creekview Dr., Waco, TX 76711, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Moviegoers say this movie theater offers comfortable reclining seats, a wide variety of drinks, and delicious popcorn. They also highlight the friendly staff and clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-abb4-7338-8e3a-6985a7accb0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-abb4-7338-8e3a-6985a7accb0e",
        "storage_key": "property/6767906449165639/019d7913-abb4-7338-8e3a-6985a7accb0e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-waco/cinemark-waco-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MjY4NDU4MzUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12111383986001443482&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-waco-and-xd",
      "poi_latitude": "31.5041964",
      "poi_longitude": "-97.148018",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-499-3273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-c297-72aa-90ed-f7bdba9f91df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-c297-72aa-90ed-f7bdba9f91df",
        "storage_key": "property/6767906449165639/019d7913-c297-72aa-90ed-f7bdba9f91df.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3QmKfZuBT4YRmnr4_5BHFKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_03b92f37-f7c2-443d-b661-3835a74b5a60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Main Event Waco",
      "poi_type": "Entertainment",
      "poi_address": "2420 Creekview Dr., Waco, TX 76711, USA",
      "poi_short_description": "Family-friendly entertainment center offering bowling, laser tag and arcade games.",
      "poi_long_description": "People say this restaurant offers a variety of fun activities, including bowling, laser tag, and arcade games, as well as delicious pizza and wings. They highlight the lively and welcoming atmosphere, and the friendly and helpful staff. They also like the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-afcc-76a6-8b8e-36e527b63f70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-afcc-76a6-8b8e-36e527b63f70",
        "storage_key": "property/6767906449165639/019d7913-afcc-76a6-8b8e-36e527b63f70.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mainevent.com/waco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12340595568029274912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-event-waco",
      "poi_latitude": "31.5055942",
      "poi_longitude": "-97.1473834",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-256-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXz3vrSBT4YRIBMlLUmaQqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_571dcd32-951f-4141-802b-6dad5654fbac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Topgolf Waco",
      "poi_type": "Entertainment",
      "poi_address": "2301 Creekview Dr., Waco, TX 76711, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun and exciting experience with excellent service from the staff and management. They also highlight the delicious food and drinks, as well as the engaging game options like Sonic and Angry Birds.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-b658-745d-afc6-7c43035f73a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b658-745d-afc6-7c43035f73a1",
        "storage_key": "property/6767906449165639/019d7913-b658-745d-afc6-7c43035f73a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://topgolf.com/us/waco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13729390873098416531&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "topgolf-waco",
      "poi_latitude": "31.5036082",
      "poi_longitude": "-97.1506348",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-379-9210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2d-754e-bc2f-55b756b67d2c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2d-754e-bc2f-55b756b67d2c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQhfrRiBT4YRk3GF9UGYiL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e3b91e66-95d5-4120-b334-c59074647ec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Waco ISD Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1401 S New Rd, Waco, TX 76711, USA",
      "poi_short_description": "Clean outdoor venue offering concessions and plenty of parking.",
      "poi_long_description": "People say this stadium offers a spacious open-air entertainment arena and is a great facility for events like graduations and football games. They highlight the friendly staff and ample parking. They also like the professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-ba33-771e-9f47-e687b2d84d6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ba33-771e-9f47-e687b2d84d6c",
        "storage_key": "property/6767906449165639/019d7913-ba33-771e-9f47-e687b2d84d6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wacoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15536238726280488529&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waco-isd-stadium",
      "poi_latitude": "31.5081383",
      "poi_longitude": "-97.1598713",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-745-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb2b-762a-8fef-b1fd84f46f6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb2b-762a-8fef-b1fd84f46f6c",
        "storage_key": "property/6767906449165639/019cfb4b-cb2b-762a-8fef-b1fd84f46f6c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ80UJF2BT4YRUaadmc7Om9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_40fa39ff-7186-4332-8121-27a9edefb5eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "poi_name": "Red Men Museum and Library",
      "poi_type": "Entertainment",
      "poi_address": "4521 Speight Ave, Waco, TX 76711, USA",
      "poi_short_description": "Reference library & artifacts of the Improved Order of Red Men, a patriotic fraternal organization.",
      "poi_long_description": "Reference library & artifacts of the Improved Order of Red Men, a patriotic fraternal organization.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019d7913-bb66-7048-b97a-9993dca11187.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bb66-7048-b97a-9993dca11187",
        "storage_key": "property/6767906449165639/019d7913-bb66-7048-b97a-9993dca11187.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.redmenhall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2564556135077660782&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-men-museum-and-library",
      "poi_latitude": "31.5126734",
      "poi_longitude": "-97.1571962",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-756-1221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-cb35-70ee-81d8-a545b8ecd24a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-cb35-70ee-81d8-a545b8ecd24a",
        "storage_key": "property/6767906449165639/019cfb4b-cb35-70ee-81d8-a545b8ecd24a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJPbgoXGeBT4YRbkjanTcilyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c3dd709385a1a85c59b0c829",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4cee2fd9c00918d16b33a480",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6b55047970881aecf32c38f1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3d3ed21f5b68d4eb211f3979",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3148edce927e227fae28312f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_d0899ca165eb0f04efe47b1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9435e900-6f84-4286-85f0-531dfa47a508",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "rating": "5.0",
      "name": "Phillip F",
      "text": "Lived here for 5+ years and had no real issues at all.  The move out process was painless and Kendall was absolutely amazing, he made it enjoyable somehow.  Kendall is the man!",
      "date": "2025-05-15",
      "title": ""
    },
    {
      "id": "custom_e29728da-d716-4b6e-b6b2-1a8c148b7621",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "rating": "5.0",
      "name": "Ben Teer",
      "text": "Great Property! Would highly recommend!!",
      "date": "2025-09-26",
      "title": ""
    },
    {
      "id": "custom_0063dbb3-28d4-4a43-a41a-5ca2752b3bf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "rating": "5.0",
      "name": "Alaa Abu Assi",
      "text": "The best apartment I have lived in for years",
      "date": "2025-02-16",
      "title": ""
    },
    {
      "id": "custom_57b2a7ab-c8dd-4b65-89ca-180e5b3360a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "rating": "5.0",
      "name": "Faith Rogers",
      "text": "Maintenance is prompt & awesome at fixing an issue even if it’s just a light bulb. I love these apartments have lived here for a while with zero complaints.best apartments in Waco all the way around.  If you’re thinking of moving here , do it you will love it.",
      "date": "2025-08-24",
      "title": ""
    },
    {
      "id": "custom_04203efd-28e8-4470-8f1c-7e6c8f198c06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "rating": "5.0",
      "name": "Russell Brown",
      "text": "Thank you for getting this done. When I got home from being out of town, I was thankful it was done. Thank you again.",
      "date": "2025-09-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_00455b4a-c21a-4ff1-b4df-89260ad6bc7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4c-721c-72df-adcd-4f6663b02d77.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment complex pool and lounge area",
        "public_id": "019cfb4c-721c-72df-adcd-4f6663b02d77",
        "storage_key": "property/6767906449165639/019cfb4c-721c-72df-adcd-4f6663b02d77.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Tuscany Ranch Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f43f47a8ff20846d0c884cb&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-b8a8-73cf-9bd4-608fd48bdb90",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "tuscany-ranch-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639"
    },
    {
      "lead_collector_id": "019cf79d-b919-7287-95f3-cad365186f86",
      "lead_source": "LANDING_PAGE",
      "name": "tuscany-ranch-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-waco-tx",
      "search_query": "pet-friendly apartments in Waco TX",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Waco, TX",
      "h2_subtitle": "Discover our pet-friendly apartments in Waco, offering spacious living with modern amenities. Enjoy pet play areas and scenic walking trails today.",
      "page_copy": "Welcome to Tuscany Ranch Apartments, the ideal choice for those searching for pet-friendly apartments in Waco, TX. Our community is perfect for you and your furry friend, with ample outdoor spaces including a dedicated dog park and pet play area. Enjoy scenic walking trails that meander throughout the property, making it easy to maintain an active lifestyle with your pet.\n\nBeyond our pet-centric features, Tuscany Ranch offers modern conveniences such as a sparkling pool, a well-equipped fitness center, and concierge services. Our spacious one- and two-bedroom floor plans are designed with both style and comfort in mind to create the perfect retreat. Make Tuscany Ranch Apartments your next home, where both you and your pets are welcomed with open arms.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
      "featured_image_media": {
        "alt_text": "Exterior courtyard and building entrance with Spanish-style architecture.",
        "public_id": "019cfb4b-a913-70ba-8ff7-7db26fe5fd95",
        "storage_key": "property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Waco, TX",
      "seo_description": "Find pet-friendly apartments in Waco, TX at Tuscany Ranch. Enjoy a dog park, walking trails, and modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-waco",
      "search_query": "apartments with in-unit laundry Waco",
      "category": "Amenity",
      "h1_title": "Waco Apartments with In-Unit Laundry",
      "h2_subtitle": "Experience comfort at Tuscany Ranch Apartments in Waco, featuring spacious units with in-unit laundry among other modern amenities.",
      "page_copy": "At Tuscany Ranch Apartments in Waco, we prioritize convenience with our in-unit laundry facilities, ensuring you enjoy modern apartment living at its finest. Our spacious one- and two-bedroom floor plans are designed to meet your needs, providing a blend of style and functionality. Say goodbye to shared laundry rooms and take advantage of the privacy and ease of having your own laundry setup.\n\nBeyond in-unit conveniences, Tuscany Ranch offers an array of amenities including a refreshing pool, state-of-the-art fitness center, dog park, and scenic walking trails. Enjoy the luxurious lifestyle that comes with concierge services and pet-friendly options. Our community offers the perfect retreat in Waco, where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
      "featured_image_media": {
        "alt_text": "Exterior courtyard and building entrance with Spanish-style architecture.",
        "public_id": "019cfb4b-a913-70ba-8ff7-7db26fe5fd95",
        "storage_key": "property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waco Apartments with In-Unit Laundry",
      "seo_description": "Discover Waco's best apartments with in-unit laundry. At Tuscany Ranch, enjoy modern amenities and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "generator",
      "page_item_url": "waco-apartments-air-conditioning",
      "search_query": "Waco apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Waco Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool at Tuscany Ranch Apartments in Waco, where every unit features air conditioning alongside a variety of luxury amenities.",
      "page_copy": "Beat the Texas heat at Tuscany Ranch Apartments, your go-to destination for Waco apartments with air conditioning. Each of our spacious one- and two-bedroom units is equipped with modern air conditioning systems, ensuring a comfortable living environment no matter the season. Experience the perfect blend of comfort and style in a vibrant community.\n\nTuscany Ranch Apartments not only provides climate-controlled living but also offers premium amenities such as a sparkling pool, fitness center, and pet-friendly spaces. Take advantage of our concierge services, and enjoy leisurely walks along scenic trails with your furry friend. Discover a lifestyle of comfort and convenience at our Waco location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
      "featured_image_media": {
        "alt_text": "Exterior courtyard and building entrance with Spanish-style architecture.",
        "public_id": "019cfb4b-a913-70ba-8ff7-7db26fe5fd95",
        "storage_key": "property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waco Apartments with Air Conditioning",
      "seo_description": "Discover Tuscany Ranch in Waco, where our apartments feature air conditioning. Enjoy comfort and convenience with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-waco-tx",
      "search_query": "luxury apartments with a pool Waco TX",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with a Pool in Waco, TX",
      "h2_subtitle": "Indulge in luxury living at Tuscany Ranch Apartments in Waco, TX, featuring a stunning pool and upscale amenities for your enjoyment.",
      "page_copy": "Step into the epitome of luxury at Tuscany Ranch Apartments in Waco, TX, where our community boasts a beautifully maintained pool perfect for relaxation and recreation. Let the serene waters offer you a refreshing escape from the everyday hustle. Our luxury apartments complement this amenity with spacious floor plans and high-end finishes designed for your ultimate comfort.\n\nBeyond the pool, Tuscany Ranch offers a range of elite amenities such as a state-of-the-art fitness center, pet-friendly areas including a dog park, and scenic walking trails. Experience the convenience of concierge services within a community that caters to your every need. Choose Tuscany Ranch and elevate your lifestyle in Waco.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
      "featured_image_media": {
        "alt_text": "Exterior courtyard and building entrance with Spanish-style architecture.",
        "public_id": "019cfb4b-a913-70ba-8ff7-7db26fe5fd95",
        "storage_key": "property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with a Pool in Waco, TX",
      "seo_description": "Tuscany Ranch offers luxury living with a pool in Waco, TX. Enjoy upscale amenities and serene environments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-near-76711",
      "search_query": "dog-friendly apartments near 76711",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments Near 76711",
      "h2_subtitle": "Tuscany Ranch Apartments near 76711 is a paradise for dog lovers, offering pet-friendly spaces including an expansive dog park.",
      "page_copy": "If you're looking for dog-friendly apartments near 76711, Tuscany Ranch Apartments in Waco is the perfect choice. Our community warmly welcomes your four-legged family members with dedicated pet-friendly spaces designed for their play and comfort. With our on-site dog park, your dogs can enjoy the freedom to roam and socialize with other pets in a secure environment.\n\nBeyond the pet amenities, Tuscany Ranch offers residents a variety of features such as spacious one- and two-bedroom units, a sparkling pool, and modern fitness facilities. Experience the convenience of living in a pet-focused community where both you and your pets can thrive, all while enjoying the vibrant lifestyle of Waco, Texas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
      "featured_image_media": {
        "alt_text": "Exterior courtyard and building entrance with Spanish-style architecture.",
        "public_id": "019cfb4b-a913-70ba-8ff7-7db26fe5fd95",
        "storage_key": "property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near 76711",
      "seo_description": "Find dog-friendly apartments near 76711 at Tuscany Ranch. Enjoy pet amenities including a dog park, and modern living in Waco.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-waco-tx",
      "search_query": "one bedroom apartments Waco TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Waco, TX",
      "h2_subtitle": "Discover the perfect one-bedroom apartment at Tuscany Ranch in Waco, TX, combining modern amenities with a peaceful lifestyle.",
      "page_copy": "Looking for one bedroom apartments in Waco, TX? Tuscany Ranch Apartments offers the ideal space with thoughtfully designed layouts that maximize comfort and functionality. Our one-bedroom units are perfect for those seeking a cozy yet modern living environment, equipped with features like a fully-fitted kitchen and air conditioning to ensure a comfortable climate year-round.\n\nAt Tuscany Ranch, residents enjoy more than just a place to live. Delight in community amenities such as a sparkling pool, fitness center, and convenient pet-friendly spaces including a dedicated dog park. Whether you're taking a rejuvenating swim or enjoying a stroll around our walking trails, you'll find that a peaceful and fulfilling lifestyle awaits you in our welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
      "featured_image_media": {
        "alt_text": "Exterior courtyard and building entrance with Spanish-style architecture.",
        "public_id": "019cfb4b-a913-70ba-8ff7-7db26fe5fd95",
        "storage_key": "property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Waco, TX",
      "seo_description": "Discover one-bedroom apartments in Waco, TX at Tuscany Ranch. Enjoy modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165639",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-76711",
      "search_query": "two bedroom apartments near 76711",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 76711",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Tuscany Ranch near 76711, offering modern amenities and convenient living.",
      "page_copy": "Searching for two bedroom apartments near 76711? Tuscany Ranch Apartments in Waco offers spacious layouts that cater to your lifestyle needs. Our two-bedroom units are ideal for families, roommates, or anyone seeking additional space in a comfortable setting. Each apartment is designed with modern conveniences, providing a balance of style and functionality.\n\nLiving at Tuscany Ranch means enjoying more than just a cozy home. Experience top-tier community amenities such as a sparkling pool for leisurely swims, a fitness center equipped with the latest gear, and pet-friendly areas including a dog park. Nestled in a prime location near the heart of Waco, Tuscany Ranch is perfect for those wishing to blend city living with a serene neighborhood vibe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
      "featured_image_media": {
        "alt_text": "Exterior courtyard and building entrance with Spanish-style architecture.",
        "public_id": "019cfb4b-a913-70ba-8ff7-7db26fe5fd95",
        "storage_key": "property/6767906449165639/019cfb4b-a913-70ba-8ff7-7db26fe5fd95.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 76711",
      "seo_description": "Discover spacious two-bedroom apartments near 76711 at Tuscany Ranch. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5224"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-R4E83854F5"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151374"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/tuscany-ranch/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NRBT5XMB"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165639/019d1bda-b201-7101-9768-35feffb361a2.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-784-4633"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "653851f935b4c74b83fcf2dc"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IktST3hjZE1sTmZVQU0xaHpMK2tSbkE9PSIsInZhbHVlIjoiUytkVjUzcEVhRkVqSEVUNDNBZEhBZz09IiwibWFjIjoiYTc1M2ZlZjllNWFiOGM0OTgxMjUxODZkNzM5NTY4NTVhY2QwNDQyYmE3Zjg1OWU4MWU4NTM1YmM2Yzc4NzA0MCJ9"
    }
  ],
  "custom_qb_id": "5224",
  "custom_ga4_id": "G-R4E83854F5",
  "custom_repli_id": "10041151374",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/tuscany-ranch/register/",
  "custom_google_gtm_id": "GTM-NRBT5XMB",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165639/019d1bda-b201-7101-9768-35feffb361a2.pdf",
  "custom_ppc_tracking_phone_number": "833-784-4633",
  "custom_residentboost_apartment_id": "653851f935b4c74b83fcf2dc",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IktST3hjZE1sTmZVQU0xaHpMK2tSbkE9PSIsInZhbHVlIjoiUytkVjUzcEVhRkVqSEVUNDNBZEhBZz09IiwibWFjIjoiYTc1M2ZlZjllNWFiOGM0OTgxMjUxODZkNzM5NTY4NTVhY2QwNDQyYmE3Zjg1OWU4MWU4NTM1YmM2Yzc4NzA0MCJ9"
};

export const generatedAt = '2026-08-27T21:35:08.814Z';
